import { useState, useEffect, useRef } from "react";
import { useAuth } from "../context/AuthContext";
import SeguimientoViajes from "./SeguimientoViajes";
import ViajesDashboard from "./Viajesdashboard";
import PdfPreviewModal from "./PdfPreviewModal";
import {
  Package,
  Truck,
  Users,
  MapPin,
  Building2,
  UserCheck,
  User,
  Search,
  Filter,
  Plus,
  Edit,
  Trash2,
  Eye,
  Calendar,
  Clock,
  Navigation,
  CheckCircle,
  AlertCircle,
  ArrowRight,
  RotateCcw,
  Download,
  Upload,
  RefreshCw,
  Route,
  Play,
  Pause,
  Square,
  TrashIcon,
  X,
} from "lucide-react";
import Select from "react-select";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import usePermissions from "../hooks/usePermissions";
import ReplayViaje from "./ReplayViaje";
const Viajes = ({ activeSection }) => {
  const { user } = useAuth();
  const evidenciasPermisos = usePermissions("viajes");
  // ✅ AGREGAR ESTE LOG TEMPORAL
  useEffect(() => {
    console.log("🔍 DEBUG - Permisos de evidencias:", evidenciasPermisos);
    console.log(
      "🔍 DEBUG - can_view_evidencias:",
      evidenciasPermisos.can_view_evidencias,
    );
    console.log("🔍 DEBUG - Usuario:", user);
  }, [evidenciasPermisos, user]);
  const [viajes, setViajes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingTabla, setLoadingTabla] = useState(false);
  const [loadingFormulario, setLoadingFormulario] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState("create");
  const [selectedViaje, setSelectedViaje] = useState(null);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [userRole, setUserRole] = useState("");
  const [loadingVehiculosConductor, setLoadingVehiculosConductor] =useState(false);
  const [hintVehiculos, setHintVehiculos] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [fechaDesde, setFechaDesde] = useState(new Date(Date.now() - 86400000).toISOString().split('T')[0]);
  const [fechaHasta, setFechaHasta] = useState(new Date().toISOString().split('T')[0]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterStatus, setFilterStatus] = useState("all");
  const [sortField, setSortField] = useState("fechaCreacion");
  const [sortDirection, setSortDirection] = useState("desc");
  const [showAlert, setShowAlert] = useState(false);
  const [showSeguimiento, setShowSeguimiento] = useState(false);
  const [showReplay, setShowReplay] = useState(false);
  const [replayViaje, setReplayViaje] = useState(null);
  const [viajesFiltradosDashboard, setViajesFiltradosDashboard] = useState([]);
  const [showTramosModal, setShowTramosModal] = useState(false);
  const [vehiculosDisponibles, setVehiculosDisponibles] = useState([]);
  const [carretasDisponibles, setCarretasDisponibles] = useState([]);
  const [conductoresDisponibles, setConductoresDisponibles] = useState([]);
  const [isPrimerTramo, setIsPrimerTramo] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isSavingTramo, setIsSavingTramo] = useState(false);
  const [showPdfPreview, setShowPdfPreview] = useState(false);
  const [pdfPreviewUrl, setPdfPreviewUrl] = useState("");
  const [pdfPreviewLoading, setPdfPreviewLoading] = useState(false);
  const [pdfDownloadLoading, setPdfDownloadLoading] = useState(false);
  const [nuevoTramo, setNuevoTramo] = useState({
    origen: { establecimientoId: "", nombre: "", tipo: "" },
    destino: { establecimientoId: "", nombre: "", tipo: "" },
    estado: "pendiente",
    tipoActividad: "",
    fechaLlegadaOrigen: (() => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`; })(),
    horaLlegadaOrigen: new Date().toTimeString().split(" ")[0].substring(0, 5),
    fechaSalidaDestino: (() => { const d = new Date(Date.now() + 2 * 60 * 60 * 1000); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`; })(),
    horaSalidaDestino: new Date(Date.now() + 2 * 60 * 60 * 1000)
      .toTimeString()
      .split(" ")[0]
      .substring(0, 5),
    observaciones: "",
    tractoId: "",
    chasisId: "",
    conductorId: "",
  });
  const [editTramoId, setEditTramoId] = useState(null);
  const API_BASE_URL = process.env.REACT_APP_VILOX_FLOTA_API;
  const API_LARAVEL_URL = process.env.REACT_APP_API_URL;

  const [alertConfig, setAlertConfig] = useState({
    type: "success",
    title: "",
    message: "",
    onConfirm: null,
    showCancel: false,
  });

  const [formData, setFormData] = useState(() => {
    const ahora = new Date();
    const dosHorasDespues = new Date(ahora.getTime() + 2 * 60 * 60 * 1000);

    return {
      tipoOperacion: "exportacion",
      codigoViaje: "",
      contenedor: "",
      transportistaId: "",
      operadorLogisticoId: "",
      camionId: "",
      chasisId: "",
      choferId: "",
      clienteId: "",
      origen: {
        tipo: "almacen",
        nombre: "",
        direccion: "",
        coordenadas: { lat: "", lng: "" },
      },
      destino: {
        tipo: "planta",
        nombre: "",
        direccion: "",
        coordenadas: { lat: "", lng: "" },
      },
      tramos: [
        {
          origen: { establecimientoId: "", nombre: "", tipo: "" },
          destino: { establecimientoId: "", nombre: "", tipo: "" },
          estado: "pendiente",
          tipoActividad: "recojo",

          fechaLlegadaOrigen: ahora.toISOString().split("T")[0],
          horaLlegadaOrigen: ahora.toTimeString().split(" ")[0].substring(0, 5),
          fechaSalidaDestino: dosHorasDespues.toISOString().split("T")[0],
          horaSalidaDestino: dosHorasDespues
            .toTimeString()
            .split(" ")[0]
            .substring(0, 5),
          observaciones: "",
        },
      ],
      fechaInicio: "",
      fechaEstimadaFin: "",
      fechaFinProgramada: "",
      observaciones: "",
      navieraId: "",
    };
  });

  const [transportistas, setTransportistas] = useState([]);
  const [operadoresLogisticos, setOperadoresLogisticos] = useState([]);
  const [camiones, setCamiones] = useState([]);
  const [choferes, setChoferes] = useState([]);
  const [chasis, setChasis] = useState([]);
  const [clientes, setClientes] = useState([]);

  const [navieras, setNavieras] = useState([]);
  const [establecimientos, setEstablecimientos] = useState([]);
  const [establecimientosFiltrados, setEstablecimientosFiltrados] = useState(
    [],
  );

  const [showEvidenciasModal, setShowEvidenciasModal] = useState(false);
  const [selectedHito, setSelectedHito] = useState("");
  const [evidenciasViaje, setEvidenciasViaje] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [evidenciasList, setEvidenciasList] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingViajeId, setEditingViajeId] = useState(null);
  const [showDropdown, setShowDropdown] = useState({});
  const [selectedViajeForDropdown, setSelectedViajeForDropdown] =
    useState(null);
  const [dropdownPositions, setDropdownPositions] = useState({});
  const [isMobile, setIsMobile] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [loadingEvidencias, setLoadingEvidencias] = useState(false);
  const [allEvidencias, setAllEvidencias] = useState([]);
  const [activeEvidenciaSetKey, setActiveEvidenciaSetKey] = useState("1");

  const getApiHeaders = () => {
    const token = localStorage.getItem("token");
    console.log("Token disponible:", !!token);

    return {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...(token && { Authorization: `Bearer ${token}` }),
    };
  };

  
  const obtenerFechasDefecto = () => {
    const ahora = new Date();
    const dosHorasDespues = new Date(ahora.getTime() + 2 * 60 * 60 * 1000);

    // ✅ USAR toLocaleDateString para obtener fecha local
    const fechaActual = ahora.toLocaleDateString("en-CA"); // YYYY-MM-DD formato local
    const fechaDosHoras = dosHorasDespues.toLocaleDateString("en-CA");

    // ✅ USAR toLocaleTimeString para obtener hora local
    const horaActual = ahora.toLocaleTimeString("en-GB", {
      hour12: false,
      hour: "2-digit",
      minute: "2-digit",
    }); // HH:MM formato

    const horaDosHoras = dosHorasDespues.toLocaleTimeString("en-GB", {
      hour12: false,
      hour: "2-digit",
      minute: "2-digit",
    });

    return {
      fechaActual,
      horaActual,
      fechaDosHoras,
      horaDosHoras,
    };
  };

  const evidenciasSets = {
    1: {
      hito: "PREVIO_SERVICIO",
      nombre: "Previo al servicio",
      titulo: "Paso 1: Previo al servicio",
      fotos: [
        { nombre: "Booking", obligatorio: true },
        { nombre: "Carta de precinto", obligatorio: true },
        { nombre: "Carta de temperatura", obligatorio: false },
      ],
    },
    2: {
      hito: "LLEGADA_DEPOT",
      nombre: "Llegada al depot",
      titulo: "Paso 2: Llegada al depot",
      fotos: [
        { nombre: "Registro", obligatorio: false },
        { nombre: "Foto exterior de depot", obligatorio: true },
      ],
    },
    3: {
      hito: "SALIDA_DEPOT",
      nombre: "Salida depot",
      titulo: "Paso 3: Salida depot",
      fotos: [
        { nombre: "EIR", obligatorio: true },
        { nombre: "Precinto de aduana", obligatorio: true },
        { nombre: "Precinto de línea", obligatorio: true },
        { nombre: "Puerta de contenedor", obligatorio: true },
        { nombre: "Precinto de puerta", obligatorio: true },
        { nombre: "Maquinaria contenedor", obligatorio: false },
        { nombre: "Ventilas de reefer", obligatorio: false },
        { nombre: "Thermoregistros", obligatorio: false },
        { nombre: "Filtros", obligatorio: false },
        { nombre: "Cortina", obligatorio: false },
        { nombre: "Sensores", obligatorio: false },
      ],
    },
    4: {
      hito: "INGRESO_SALIDA_COCHERA",
      nombre: "Ingreso - Salida cochera",
      titulo: "Paso 4: Ingreso - Salida cochera (Solo si es anticipado)",
      condicional: true,
      fotos: [
        { nombre: "Pernocte en cochera - Ingreso", obligatorio: true },
        { nombre: "Precinto de puerta - Salida", obligatorio: true },
      ],
    },
    5: {
      hito: "LLEGADA_PLANTA",
      nombre: "Llegada a planta",
      titulo: "Paso 5: Llegada a planta",
      fotos: [
        { nombre: "Precinto de puerta - Salida", obligatorio: true },
        { nombre: "Foto exterior de planta", obligatorio: true },
        { nombre: "Temperatura de reefer", obligatorio: false },
      ],
    },
    6: {
      hito: "TERMINO_CARGA",
      nombre: "Término de carga",
      titulo: "Paso 6: Término de carga",
      fotos: [
        { nombre: "Guía de remisión remitente", obligatorio: true },
        { nombre: "Guía transportista", obligatorio: true },
        { nombre: "Pesos y medidas", obligatorio: true },
        { nombre: "Puerta de contenedor", obligatorio: true },
        { nombre: "Precinto de línea", obligatorio: true },
        { nombre: "Precinto aduana", obligatorio: true },
        { nombre: "Precinto SENASA-SANIPES", obligatorio: true },
        { nombre: "Precinto exportador", obligatorio: false },
        { nombre: "Temperatura reefer", obligatorio: false },
      ],
    },
    7: {
      hito: "LLEGADA_PUERTO",
      nombre: "Llegada a puerto",
      titulo: "Paso 7: Llegada a puerto",
      fotos: [
        { nombre: "Registro", obligatorio: false },
        { nombre: "Foto exterior de puerto", obligatorio: true },
        { nombre: "Puerta de contenedor", obligatorio: false },
        { nombre: "Temperatura reefer", obligatorio: false },
      ],
    },
    8: {
      hito: "SALIDA_PUERTO",
      nombre: "Salida de puerto",
      titulo: "Paso 8: Salida de puerto",
      fotos: [{ nombre: "Ticket de balanza", obligatorio: true }],
    },
  };

  const closeImagePreview = () => {
    setImagePreview(null);
  };

  useEffect(() => {
    const fechasDefecto = obtenerFechasDefecto();
    setFormData((prev) => ({
      ...prev,
      tramos: prev.tramos.map((tramo, index) => {
        if (index === 0 || !tramo.fechaLlegadaOrigen) {
          return {
            ...tramo,
            tipoActividad: index === 0 ? "recojo" : tramo.tipoActividad,
            fechaLlegadaOrigen: fechasDefecto.fechaActual,
            horaLlegadaOrigen: fechasDefecto.horaActual,
            fechaSalidaDestino: fechasDefecto.fechaDosHoras,
            horaSalidaDestino: fechasDefecto.horaDosHoras,
          };
        }
        return tramo;
      }),
    }));
  }, []);

  useEffect(() => {
    const checkMobile = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const isMobileDevice =
        /android|blackberry|iphone|ipad|ipod|opera mini|iemobile|wpdesktop/i.test(
          userAgent,
        );
      setIsMobile(isMobileDevice);
    };

    checkMobile();
  }, []);

  useEffect(() => {
    if (showTramosModal) {
      fetchVehiculos();
      fetchCarretas();
      fetchConductores();
    }
  }, [showTramosModal]);

  useEffect(() => {
    if (showTramosModal && editTramoId && conductoresDisponibles.length > 0) {
      const tramoEditado = selectedViaje.tramos.find(
        (t) => t.id === editTramoId,
      );

      if (tramoEditado) {
        const conductorActual =
          tramoEditado.conductor?.id || tramoEditado.conductor || "";

        const existeEnLista = conductoresDisponibles.some(
          (c) => c.id === conductorActual,
        );

        if (existeEnLista && nuevoTramo.conductorId !== conductorActual) {
          setNuevoTramo((prev) => ({ ...prev, conductorId: conductorActual }));
        }
      }
    }
  }, [conductoresDisponibles, showTramosModal]);
const fetchViajesLista = async (desde, hasta) => {
  // ✅ Usar los valores de estado actuales si no se pasan argumentos
  const desdeFinal = (typeof desde === 'string' && desde) ? desde : fechaDesde;
  const hastaFinal = (typeof hasta === 'string' && hasta) ? hasta : fechaHasta;

  try {
    setLoadingTabla(true);
    setLoadingMessage('Cargando viajes...');
    let apiUrl;
    switch (user.tipo) {
      case 'transportista':
        apiUrl = `${API_LARAVEL_URL}/viajes/empresa/${user.empresa_id}/lista`;
        break;
      case 'operador_logistico':
        apiUrl = `${API_LARAVEL_URL}/viajes/operador/${user.empresa_id}/lista`;
        break;
      case 'exportador':
      case 'cliente':
        apiUrl = `${API_LARAVEL_URL}/viajes/cliente/${user.empresa_id}/lista`;
        break;
      case 'conductor':
        apiUrl = `${API_LARAVEL_URL}/viajes/conductor/${user.id}/lista`;
        break;
      default: return;
    }

    apiUrl += `?desde=${desdeFinal}&hasta=${hastaFinal}`;

    const res = await fetch(apiUrl, { headers: getApiHeaders() });
    const data = await res.json();
    setViajes(Array.isArray(data) ? data : []);
  } catch (err) {
    console.error('Error cargando lista:', err);
    setViajes([]);
  } finally {
    setLoadingTabla(false);
    setLoadingMessage('');
  }
};
const fetchViajeDetalle = async (viajeId) => {
  try {
    setLoading(true);
    setLoadingMessage('Cargando detalle...');
    const res = await fetch(
      `${API_LARAVEL_URL}/viajes/${viajeId}/vista`,  // ← CAMBIO 1: nueva ruta
      { headers: getApiHeaders() }
    );
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const data = await res.json();

    // CAMBIO 2: transformar campos planos → objetos anidados que espera el modal
    const viaje = {
      ...data,
      empresaTransportista: { nombre: data.transportistaNombre },
      empresaOperador:      { nombre: data.operadorNombre },
      empresaCliente:       { nombre: data.clienteNombre },
      empresaNaviera:       { nombre: data.navieraNombre },
      vehiculo:             { placa: data.vehiculoPlaca },
      carreta:              { placa: data.carretaPlaca },
      conductor: {
        nombre:            data.conductorNombre?.split(' ')[0] || '',
        apellidos:         data.conductorNombre?.split(' ').slice(1).join(' ') || '',
        licenciaCategoria: data.licenciaCategoria,
      },
      tramos: (data.tramos || []).map(t => ({
        ...t,
        establecimientoOrigen:  { id: t.establecimientoOrigenId,  nombre: t.origenNombre,  direccion: t.origenDireccion },
        establecimientoDestino: { id: t.establecimientoDestinoId, nombre: t.destinoNombre, direccion: t.destinoDireccion },
      })),
    };

    setSelectedViaje(viaje);   // ← ahora sí tiene la estructura que espera el modal
    setModalType('view');
    setShowModal(true);
  } catch (err) {
    showAlertSwal('error', 'Error', 'No se pudo cargar el detalle');
  } finally {
    setLoading(false);
    setLoadingMessage('');
  }
};
  const fetchViajes = async () => {
    try {
      setLoading(true);
      setLoadingMessage("Cargando viajes...");
      // ✅ AGREGAR ESTOS LOGS
      console.log("👤 Usuario completo:", user);
      console.log("🔑 user.tipo:", user.tipo);
      console.log("🆔 user.id:", user.id);

      let apiUrl;
      switch (user.tipo) {
        case "transportista":
          apiUrl = `${API_LARAVEL_URL}/viajes/empresa/${user.empresa_id}`;
          break;
        case "operador_logistico":
          apiUrl = `${API_LARAVEL_URL}/viajes/operador/${user.empresa_id}`;
          break;
        case "exportador":
        case "cliente":
          apiUrl = `${API_LARAVEL_URL}/viajes/cliente/${user.empresa_id}`;
          break;
        case "conductor":
          apiUrl = `${API_LARAVEL_URL}/viajes/conductor/${user.id}`;
          break;
        default:
          console.error("Tipo de usuario no reconocido:", user.tipo);
          return;
      }
      console.log("📡 URL generada:", apiUrl); // ✅ AGREGAR ESTE LOG
      const res = await fetch(apiUrl, {
        headers: getApiHeaders(),
      });

      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const data = await res.json();
      // 🔍 DEBUG COMPLETO - AGREGAR ESTO
      console.group("🔍 ANÁLISIS DETALLADO DE VIAJES");
      console.log("📦 Total recibidos del backend:", data.length);
      console.log(
        "📊 Viajes sin código:",
        data.filter((v) => !v.codigoViaje).length,
      );
      console.log(
        "📊 Viajes con código:",
        data.filter((v) => v.codigoViaje).length,
      );

      // Ver los 3 primeros viajes sin código
      const sinCodigo = data.filter((v) => !v.codigoViaje).slice(0, 3);
      console.log(
        "📋 Primeros 3 viajes SIN código:",
        sinCodigo.map((v) => ({
          id: v.id,
          codigoViaje: v.codigoViaje,
          fechaInicioProgramada: v.fechaInicioProgramada,
          fechaCreacion: v.fechaCreacion,
          estado: v.estado,
          transportista: v.empresaTransportista?.nombre,
        })),
      );

      console.groupEnd();
      // 🔍 FIN DEBUG
      let viajesArray = [];
      if (Array.isArray(data)) {
        viajesArray = data;
      } else if (data && data.data && Array.isArray(data.data)) {
        viajesArray = data.data;
      }

      console.log("✅ Lista actualizada:", viajesArray.length, "viajes");
      setViajes(viajesArray);
    } catch (err) {
      console.error("❌ Error cargando viajes:", err);
      setViajes([]);

      if (err.message.includes("No autorizado")) {
        showAlertSwal(
          "error",
          "Sesión Expirada",
          "Su sesión ha expirado. Por favor, vuelva a iniciar sesión.",
        );
      } else {
        showAlertSwal(
          "error",
          "Error de Conexión",
          `No se pudieron cargar los viajes: ${err.message}`,
        );
      }
    } finally {
      setLoading(false);
      setLoadingMessage("");
    }
  };


useEffect(() => {
  if (!user) return;

  const formatLocalDateTime = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  switch (user.tipo) {
    case "transportista":
      setUserRole("transportista");
      setFormData((prev) => ({
        ...prev,
        transportistaId: String(user.empresa_id),
        fechaInicio: formatLocalDateTime(new Date()),
        fechaEstimadaFin: formatLocalDateTime(
          new Date(Date.now() + 24 * 60 * 60 * 1000),
        ),
      }));
      setTransportistas([
        { id: String(user.empresa_id), nombre: user.nombre },
      ]);
      // ❌ ELIMINADO: loadTransportistaData(user.empresa_id)
      break;

    case "operador_logistico":
      setUserRole("operador_logistico");
      setFormData((prev) => ({
        ...prev,
        operadorLogisticoId: user.empresa_id,
        fechaInicio: formatLocalDateTime(new Date()),
        fechaEstimadaFin: formatLocalDateTime(
          new Date(Date.now() + 24 * 60 * 60 * 1000),
        ),
      }));
      setOperadoresLogisticos([
        { id: String(user.empresa_id), nombre: user.nombre },
      ]);
      // ❌ ELIMINADO: loadOperadorData(user.empresa_id)
      break;

    case "exportador":
    case "cliente":
      setUserRole("cliente");
      setFormData((prev) => ({
        ...prev,
        clienteId: user.empresa_id,
      }));
      setClientes([{ id: user.id, nombre: user.nombre }]);
      break;

    case "conductor":
      setUserRole("conductor");
      break;

    default:
      setUserRole("");
      break;
  }
}, [user]);

  useEffect(() => {
    console.log("🔍 DEBUG ROL ASIGNADO:", {
      "user.tipo": user?.tipo,
      userRole: userRole,
      "¿Coinciden?": user?.tipo === "cliente" && userRole === "cliente",
    });
  }, [user, userRole]);
  // Helpers
  const toStr = (v) => (v == null ? "" : String(v));

  const fetchVehiculos = async () => {
    const res = await fetch(`${API_LARAVEL_URL}/catalogos/vehiculos`, {
      headers: getApiHeaders(),
    });
    const data = await res.json();
    setVehiculosDisponibles(data);
  };

  const fetchCarretas = async () => {
    const res = await fetch(`${API_LARAVEL_URL}/catalogos/carretas`, {
      headers: getApiHeaders(),
    });
    const data = await res.json();
    setCarretasDisponibles(data);
  };

  const fetchConductores = async () => {
    const res = await fetch(`${API_LARAVEL_URL}/catalogos/conductores`, {
      headers: getApiHeaders(),
    });
    const data = await res.json();
    setConductoresDisponibles(data);
  };

  const fetchEstablecimientos = async () => {
    try {
      const res = await fetch(
        `${API_LARAVEL_URL}/establecimientos?perPage=500&sortBy=nombre&sortOrder=asc`,
        { headers: getApiHeaders() }
      );
      const data = await res.json();
      if (data.success && Array.isArray(data.data)) {
        setEstablecimientos(data.data.map((e) => ({
          id: e.id,
          nombre: e.nombre,
          tipo: e.tipo,
          direccion: e.direccion,
          activo: e.activo,
          publico: e.publico,
          empresaId: e.empresa_id,
        })));
      }
    } catch (err) {
      console.error("Error cargando establecimientos:", err);
    }
  };

 const fetchVehiculosConductor = async (conductorId) => {
  if (!conductorId) return;

  // ✅ Si ya consultamos este conductor antes, usar cache
  if (vehiculosCache.current[conductorId]) {
    const cached = vehiculosCache.current[conductorId];
    setFormData((prev) => ({
      ...prev,
      ...(cached.camionId && { camionId: cached.camionId }),
      ...(cached.chasisId && { chasisId: cached.chasisId }),
    }));
    setHintVehiculos(cached.fuente);
    return; // ← no llama a la API
  }

  setLoadingVehiculosConductor(true);
  setHintVehiculos("");
  try {
    const res = await fetch(
      `${API_LARAVEL_URL}/flota/conductores/${conductorId}/vehiculos`,
      { headers: getApiHeaders() },
    );
    if (!res.ok) throw new Error();
    const { vehiculo, carreta, fuente } = await res.json();

    // ✅ Guardar en cache para la próxima vez
    vehiculosCache.current[conductorId] = {
      camionId: vehiculo?.id ? String(vehiculo.id) : null,
      chasisId: carreta?.id ? String(carreta.id) : null,
      fuente: fuente ?? "sin_asignacion",
    };

    setFormData((prev) => ({
      ...prev,
      ...(vehiculo?.id && { camionId: String(vehiculo.id) }),
      ...(carreta?.id && { chasisId: String(carreta.id) }),
    }));

    setHintVehiculos(fuente ?? "sin_asignacion");
  } catch {
    setHintVehiculos("sin_asignacion");
  } finally {
    setLoadingVehiculosConductor(false);
  }
};
  const handleDownloadReporte = async (tipo) => {
    try {
      console.log("🔍 Iniciando descarga de reporte:", tipo); // ✅ LOG

      // Obtener token
      const token = localStorage.getItem("token");

      console.log("🔑 Token encontrado:", !!token); // ✅ LOG

      if (!token) {
        showAlertSwal("error", "Error", "No hay sesión activa");
        return;
      }

      // Cerrar dropdown DESPUÉS de verificar token
      setShowDropdown({});

      // Mostrar loading
      setLoading(true);
      setLoadingMessage(`Generando reporte ${tipo.toUpperCase()}...`);

      // Hacer petición con token
      const url = `${API_LARAVEL_URL}/reportes/viajes/${tipo}`;

      console.log("📡 URL del reporte:", url); // ✅ LOG

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept:
            tipo === "pdf"
              ? "application/pdf"
              : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
      });

      console.log("📬 Respuesta del servidor:", response.status); // ✅ LOG

      if (!response.ok) {
        const errorData = await response.json().catch(() => null);
        console.error("❌ Error del servidor:", errorData); // ✅ LOG
        throw new Error(errorData?.message || "Error al generar el reporte");
      }

      // Obtener el blob
      const blob = await response.blob();

      console.log("📦 Blob recibido:", blob.size, "bytes"); // ✅ LOG

      // Crear URL temporal
      const blobUrl = window.URL.createObjectURL(blob);

      // Crear link de descarga
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = `reporte_viajes_${new Date().getTime()}.${tipo === "pdf" ? "pdf" : "xlsx"}`;

      // Simular click
      document.body.appendChild(link);
      link.click();

      // Limpiar
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);

      console.log("✅ Descarga completada"); // ✅ LOG

      showAlertSwal(
        "success",
        "Descarga Exitosa",
        `El reporte ${tipo.toUpperCase()} se ha descargado correctamente`,
      );
    } catch (error) {
      console.error("❌ Error al descargar reporte:", error);
      showAlertSwal(
        "error",
        "Error",
        error.message || "No se pudo descargar el reporte",
      );
    } finally {
      setLoading(false);
      setLoadingMessage("");
    }
  };
  // Funciones para cargar datos desde endpoints
  const loadTransportistaData = async (transportistaId) => {
    setLoadingFormulario(true);
    try {
      console.log("Transportista ID:", transportistaId);

      const response = await fetch(
        `${API_BASE_URL}/api/transportista/${transportistaId}?tipoEmpresa=transportista`,
        { headers: getApiHeaders() },
      );

      if (response.ok) {
        const data = await response.json();
        console.log("Transportista data:", data);
        const transportistaData = {
          id: String(transportistaId),
          nombre: data.nombre || "Transportista NN",
          ruc: data.ruc,
        };
        setTransportistas([transportistaData]);

        setFormData((prev) => ({
          ...prev,
          transportistaId: String(transportistaId),
        }));

        const choferesOrdenados = (data.choferes || []).sort((a, b) => {
          const apellidoA = (a.apellidos || "").toLowerCase();
          const apellidoB = (b.apellidos || "").toLowerCase();
          return apellidoA.localeCompare(apellidoB);
        });

        setChoferes(choferesOrdenados);

        setCamiones(data.camiones || []);

        setChasis(
          (data.carretas || [])
            .filter((carreta) => carreta && carreta.id)
            .map((carreta) => ({
              id: carreta.id,
              placa: carreta.placa,
            })),
        );

        setNavieras(data.navieraConAlmaceneras || []);

        setEstablecimientos(data.establecimientos || []);

        const almacenes = (data.establecimientos || []).filter(
          (est) => est.tipo === "ALMACEN",
        );
        const plantas = (data.establecimientos || []).filter(
          (est) => est.tipo === "PLANTA",
        );
        const cocheras = (data.establecimientos || []).filter(
          (est) => est.tipo === "COCHERA" && est.empresaId === transportistaId,
        );

        if (data.operadorLogisticoConClientes) {
          const operadoresData = data.operadorLogisticoConClientes.map(
            (item) => {
              const op = item.operadorLogistico || {};

              // ✅ FILTRAR CLIENTES DUPLICADOS POR clienteId
              const clientesUnicos = (op.clientes || []).filter(
                (cliente, index, array) => {
                  // Mantener solo la primera ocurrencia de cada clienteId
                  return (
                    array.findIndex(
                      (c) => c.clienteId === cliente.clienteId,
                    ) === index
                  );
                },
              );

              console.log(
                `📊 ${op.nombre}: ${op.clientes?.length || 0} → ${clientesUnicos.length
                } clientes únicos`,
              );

              return {
                id: toStr(op.operadorId),
                nombre: op.nombre,
                ruc: op.ruc,
                tipo: op.tipoEmpresa,
                clientes: clientesUnicos.map((c, clienteIndex) => ({
                  id: toStr(c.clienteId),
                  nombre: c.clienteNombre,
                  ruc: c.clienteRuc,
                  uniqueKey: `${toStr(op.operadorId)}-${toStr(
                    c.clienteId,
                  )}-${clienteIndex}`,
                })),
              };
            },
          );

          setOperadoresLogisticos(operadoresData);

          if (operadoresData.length > 0 && !formData.operadorLogisticoId) {
            setFormData((prev) => ({
              ...prev,
              operadorLogisticoId: operadoresData[0].id,
            }));
          }
        }
      } else {
        console.error("❌ ERROR EN CARGA TRANSPORTISTA");
        console.error("Status:", response.status);
        console.error("Status Text:", response.statusText);

        try {
          const errorText = await response.text();
          console.error("Error response:", errorText);
        } catch (e) {
          console.error("No se pudo leer el error del backend");
        }
      }
    } catch (error) {
      console.error("=== ERROR DE CONEXIÓN TRANSPORTISTA ===");
      console.error("Error Type:", error.constructor.name);
      console.error("Error Message:", error.message);
      console.error("Error Stack:", error.stack);

      setCamiones([]);
      setChoferes([]);
      setClientes([]);
      setOperadoresLogisticos([]);
      setNavieras([]);
      setEstablecimientos([]);
    } finally {
      setLoadingFormulario(false);
      console.log("=== FIN CARGA TRANSPORTISTA ===");
    }
  };

  const loadOperadorData = async (operadorId) => {
    console.log("🔍 INICIO loadOperadorData con operadorId:", operadorId);
    setLoadingFormulario(true);
    try {
      const url = `${API_BASE_URL}/api/operador-logistico/listarOperadores?id_empresa=${operadorId}&tipoEmpresa=operador_logistico`;
      console.log("📡 URL a llamar:", url);

      const response = await fetch(url, { headers: getApiHeaders() });

      if (response.ok) {
        const data = await response.json();

        const choferesOrdenados = (data.choferes || []).sort((a, b) => {
          const apellidoA = (a.apellidos || "").toLowerCase();
          const apellidoB = (b.apellidos || "").toLowerCase();
          return apellidoA.localeCompare(apellidoB);
        });

        setChoferes(choferesOrdenados);
        setCamiones(data.camiones || []);

        setChasis(
          (data.carretas || [])
            .filter((carreta) => carreta && carreta.id)
            .map((carreta) => ({
              id: carreta.id,
              placa: carreta.placa,
            })),
        );

        const clientesData = (data.clientes || []).map((c) => ({
          id: toStr(c.clienteId),
          nombre: c.clienteNombre,
          ruc: c.clienteRuc,
        }));
        setClientes(clientesData);

        if (data.empresaAdministradora) {
          setTransportistas([
            {
              id: toStr(data.empresaAdministradora.empresaId),
              nombre: data.empresaAdministradora.empresaNombre,
            },
          ]);
        }

        console.log("✅ DATOS PROCESADOS CORRECTAMENTE");
      } else {
        console.error("❌ Response NOT OK:", response.status);
        setCamiones([]);
        setChoferes([]);
        setChasis([]);
        setClientes([]);
        setTransportistas([]);
      }
    } catch (error) {
      console.error("💥 Error en loadOperadorData:", error);
      setCamiones([]);
      setChoferes([]);
      setChasis([]);
      setClientes([]);
      setTransportistas([]);
    } finally {
      setLoadingFormulario(false);
      console.log("✅ FIN loadOperadorData");
    }
  };

  useEffect(() => {
    if (!user) return;
    if (activeSection === "viajes") {
      // 1. Refrescar la lista de viajes
      const desde = fechaDesde || new Date(Date.now() - 86400000).toISOString().split('T')[0];
      const hasta = fechaHasta || new Date().toISOString().split('T')[0];
      fetchViajesLista(desde, hasta);
      
      // 2. Recargar catálogos principales inmediatamente en background
      const empId = user.empresa_id;
      if (user.tipo === "transportista" || userRole === "transportista") {
        loadTransportistaData(empId);
      } else if (user.tipo === "operador_logistico" || userRole === "operador_logistico") {
        loadOperadorData(empId);
      }

      // 3. Limpiar catálogos secundarios para forzar recarga en modales secundarios
      setVehiculosDisponibles([]);
      setCarretasDisponibles([]);
      setConductoresDisponibles([]);
    }
  }, [user, activeSection, userRole]);

  const viajesBase =
    viajesFiltradosDashboard.length > 0 ? viajesFiltradosDashboard : viajes;
  const filteredViajes = (Array.isArray(viajesBase) ? viajesBase : [])
    .filter((viaje) => {
      const q = searchTerm.toLowerCase();
// ✅ BIEN
const matchesSearch =
  (viaje.codigoViaje || "").toLowerCase().includes(q) ||
  (viaje.transportistaNombre || "").toLowerCase().includes(q) ||
  (viaje.clienteNombre || "").toLowerCase().includes(q);

      const matchesFilter =
        filterStatus === "all" || viaje.estado === filterStatus;

      // let matchesRole = true;
      // if (userRole === "transportista" && user?.id) {
      //   matchesRole = viaje.empresaTransportista.id === user.empresa_id;
      // } else if (userRole === "cliente" && user?.id) {
      //   matchesRole = viaje.empresaCliente.id === user.empresa_id;
      // } else if (userRole === "conductor" && user?.id) {
      //   // ✅ NUEVO: Filtro específico para conductores
      //   matchesRole = viaje.conductor?.id === user.id;
      // }

      // return matchesSearch && matchesFilter && matchesRole;
      return matchesSearch && matchesFilter;
    })
    .sort((a, b) => {
      let aValue, bValue;

      switch (sortField) {
        case "codigoViaje":
          aValue = a.codigoViaje || "";
          bValue = b.codigoViaje || "";
          break;
        case "tipoOperacion":
          aValue = a.tipoOperacion || "";
          bValue = b.tipoOperacion || "";
          break;
      // ✅ BIEN
        case "transportista":
          aValue = a.transportistaNombre || "";
          bValue = b.transportistaNombre || "";
          break;
        case "cliente":
          aValue = a.clienteNombre || "";
          bValue = b.clienteNombre || "";
          break;
        case "fechaInicioProgramada":
          aValue = new Date(a.fechaInicioProgramada || "1970-01-01"); // Fecha mínima para nulls
          bValue = new Date(b.fechaInicioProgramada || "1970-01-01");
          break;
        case "fechaFinProgramada":
          aValue = new Date(a.fechaFinProgramada || "1970-01-01"); // Fecha mínima para nulls
          bValue = new Date(b.fechaFinProgramada || "1970-01-01");
          break;
        case "estado":
          aValue = a.estado || "";
          bValue = b.estado || "";
          break;
        case "fechaCreacion":
        default:
          aValue = new Date(a.fechaCreacion || 0);
          bValue = new Date(b.fechaCreacion || 0);
          break;
      }

      if (aValue < bValue) return sortDirection === "asc" ? -1 : 1;
      if (aValue > bValue) return sortDirection === "asc" ? 1 : -1;
      return 0;
    });

  useEffect(() => {
    if (
      toStr(userRole) === "transportista" &&
      formData.operadorLogisticoId &&
      operadoresLogisticos &&
      operadoresLogisticos.length > 0
    ) {
      const operadorSeleccionado = operadoresLogisticos.find(
        (op) => toStr(op.id) === toStr(formData.operadorLogisticoId),
      );

      if (
        operadorSeleccionado &&
        Array.isArray(operadorSeleccionado.clientes) &&
        operadorSeleccionado.clientes.length > 0
      ) {
        const clientesConKeys = operadorSeleccionado.clientes.map(
          (cliente) => ({
            ...cliente,
            uniqueKey: `${toStr(operadorSeleccionado.id)}-${toStr(cliente.id)}`,
          }),
        );

        setClientes(clientesConKeys);
      } else {
        setClientes([]);
      }
    }
  }, [formData.operadorLogisticoId, operadoresLogisticos, userRole]);

  const showAlertModal = (type, title, message, onConfirm = null) => {
    setAlertConfig({ type, title, message, onConfirm });
    setShowAlert(true);
  };

  const showAlertSwal = (type, title, message, onConfirm = null) => {
    const colorMap = {
      success: { from: "from-green-500", to: "to-emerald-600" },
      error: { from: "from-red-500", to: "to-rose-600" },
      warning: { from: "from-yellow-400", to: "to-orange-500" },
      info: { from: "from-blue-500", to: "to-cyan-500" },
    };

    const { from, to } = colorMap[type] || colorMap.info;

    const config = {
      title: `<div class="text-lg font-semibold mb-1">${title}</div>`,
      html: `<div class="text-sm text-gray-700">${message}</div>`,
      icon: type,
      confirmButtonText: "Aceptar",
      buttonsStyling: false,
      customClass: {
        popup: "rounded-2xl shadow-xl border border-gray-100 p-2",
        title: "text-gray-800 font-semibold",
        htmlContainer: "text-gray-600 text-sm",
        confirmButton: `mt-3 bg-gradient-to-r ${from} ${to} text-white font-medium py-2 px-5 rounded-lg shadow hover:opacity-90 transition-all duration-200`,
        cancelButton:
          "mt-3 bg-gray-200 text-gray-700 font-medium py-2 px-5 rounded-lg hover:bg-gray-300 transition-all duration-200",
      },
      background: "#ffffff",
    };

    if (type === "warning") {
      config.showCancelButton = true;
      config.cancelButtonText = "Cancelar";
    }

    Swal.fire(config).then((result) => {
      if (result.isConfirmed && onConfirm) {
        onConfirm();
      }
    });
  };

  const showConfirmModal = (title, message, onConfirm) => {
    setAlertConfig({
      type: "warning",
      title: title,
      message: message,
      onConfirm: onConfirm,
      showCancel: true,
    });
    setShowAlert(true);
  };

  const saveViaje = async () => {
    try {
      setIsSaving(true);
      setLoadingMessage(
        isEditMode ? "Actualizando viaje..." : "Guardando viaje...",
      );

      if (isEditMode) {
        if (
          !formData.transportistaId ||
          formData.transportistaId.trim() === ""
        ) {
          showAlertSwal(
            "error",
            "Campo Requerido",
            "Debe seleccionar un transportista.",
          );
          return;
        }
        if (
          !formData.operadorLogisticoId ||
          formData.operadorLogisticoId.trim() === ""
        ) {
          showAlertSwal(
            "error",
            "Campo Requerido",
            "Debe seleccionar un Generador de Carga.",
          );
          return;
        }
        if (!formData.camionId || formData.camionId.trim() === "") {
          showAlertSwal(
            "error",
            "Campo Requerido",
            "Debe seleccionar un vehículo.",
          );
          return;
        }
        if (!formData.chasisId || formData.chasisId.trim() === "") {
          showAlertSwal(
            "error",
            "Campo Requerido",
            "Debe seleccionar un Semirremolque.",
          );
          return;
        }
        if (!formData.choferId || formData.choferId.trim() === "") {
          showAlertSwal(
            "error",
            "Campo Requerido",
            "Debe seleccionar un conductor.",
          );
          return;
        }

        const viajeData = {
          empresaTransportista: { id: formData.transportistaId },
          empresaOperador: { id: formData.operadorLogisticoId },
          vehiculo: { id: formData.camionId },
          carreta: { id: formData.chasisId },
          conductor: { id: formData.choferId },
          empresaCliente: { id: formData.clienteId },
          observaciones: formData.observaciones || "",
          fechaFinProgramada: formData.fechaFinProgramada || null,
        };
        // ✅ AGREGA ESTE LOG PARA VER QUÉ SE ENVÍA
        console.log(
          "📤 DATOS QUE SE ENVÍAN AL BACKEND:",
          JSON.stringify(viajeData, null, 2),
        );
        if (formData.navieraId && formData.navieraId.trim() !== "") {
          viajeData.empresaNaviera = { id: formData.navieraId };
        }
        if (formData.codigoViaje && formData.codigoViaje.trim() !== "") {
          viajeData.codigoViaje = formData.codigoViaje.trim();
        }
        if (formData.contenedor && formData.contenedor.trim() !== "") {
          viajeData.contenedor = formData.contenedor.trim(); // ✅ AGREGAR ESTA LÍNEA
        }
        if (
          formData.fechaFinProgramada &&
          formData.fechaFinProgramada.trim() !== ""
        ) {
          viajeData.fechaFinProgramada = formData.fechaFinProgramada;
        }
        // ✅ LOG PARA VERIFICAR
        console.log("📤 DATOS DE UPDATE:", viajeData);
        const viajeResponse = await fetch(
          `${API_LARAVEL_URL}/viajes/${editingViajeId}`,
          {
            method: "PUT",
            headers: getApiHeaders(),
            body: JSON.stringify(viajeData),
          },
        );

        const viajeResponseText = await viajeResponse.text();
        let viajeResponseData = null;

        if (viajeResponseText && viajeResponseText.trim() !== "") {
          try {
            viajeResponseData = JSON.parse(viajeResponseText);
          } catch (parseError) {
            console.error("❌ ERROR PARSEANDO JSON:", parseError.message);
          }
        }

        if (viajeResponse.ok && viajeResponseData?.success) {
          showAlertSwal(
            "success",
            "Viaje Actualizado",
            `El viaje ${formData.codigoViaje || "sin código"
            } se ha actualizado exitosamente.`,
            () => {
              setShowCreateForm(false);
              setIsEditMode(false);
              setEditingViajeId(null);
              fetchViajes();
            },
          );
        } else {
          const errorMessage =
            viajeResponseData?.message || "No se pudo actualizar el viaje.";
          showAlertSwal("error", "Error al Actualizar", errorMessage);
        }
      } else {
        if (
          !formData.transportistaId ||
          formData.transportistaId.trim() === ""
        ) {
          showAlertSwal(
            "error",
            "Campo Requerido",
            "Debe seleccionar un transportista.",
          );
          return;
        }

        if (
          !formData.operadorLogisticoId ||
          formData.operadorLogisticoId.trim() === ""
        ) {
          showAlertSwal(
            "error",
            "Campo Requerido",
            "Debe seleccionar un Generador de Carga.",
          );
          return;
        }

        if (!formData.clienteId || formData.clienteId.trim() === "") {
          showAlertSwal(
            "error",
            "Campo Requerido",
            "Debe seleccionar un cliente.",
          );
          return;
        }
        // ✅ AGREGAR ESTA VALIDACIÓN AQUÍ
        if (formData.tipoOperacion === "importacion") {
          if (!formData.clienteId || formData.clienteId.trim() === "") {
            showAlertSwal(
              "error",
              "Cliente Requerido",
              "Debe seleccionar un cliente para operaciones de importación antes de configurar los tramos.",
            );
            return;
          }

          // Validar que existan plantas del cliente
          const plantasCliente = establecimientos.filter(
            (est) =>
              est.tipo === "PLANTA" &&
              est.activo &&
              est.empresaId === formData.clienteId,
          );

          if (plantasCliente.length === 0) {
            showAlertSwal(
              "error",
              "Sin Plantas Disponibles",
              "El cliente seleccionado no tiene plantas registradas. Contacte al administrador.",
            );
            return;
          }
        }
        if (!formData.camionId || formData.camionId.trim() === "") {
          showAlertSwal(
            "error",
            "Campo Requerido",
            "Debe seleccionar un vehículo.",
          );
          return;
        }

        if (!formData.chasisId || formData.chasisId.trim() === "") {
          showAlertSwal(
            "error",
            "Campo Requerido",
            "Debe seleccionar un Semirremolque.",
          );
          return;
        }

        if (!formData.choferId || formData.choferId.trim() === "") {
          showAlertSwal(
            "error",
            "Campo Requerido",
            "Debe seleccionar un conductor.",
          );
          return;
        }

        if (
          !formData.tipoOperacion ||
          !["exportacion", "importacion"].includes(formData.tipoOperacion)
        ) {
          showAlertSwal(
            "error",
            "Campo Inválido",
            "Debe seleccionar un tipo de operación válido.",
          );
          return;
        }

        let tramosCompletos = [];

        if (formData.tramos && formData.tramos.length > 0) {
          tramosCompletos = formData.tramos.filter((tramo) => {
            const tieneOrigen =
              tramo.origen?.establecimientoId &&
              tramo.origen.establecimientoId.trim() !== "";
            const tieneDestino =
              tramo.destino?.establecimientoId &&
              tramo.destino.establecimientoId.trim() !== "";
            const tieneTipoActividad =
              tramo.tipoActividad && tramo.tipoActividad.trim() !== "";

            return tieneOrigen && tieneDestino && tieneTipoActividad;
          });
        }

        const combinarFechaHora = (fecha, hora) => {
          if (!fecha || !hora) return null;
          return `${fecha}T${hora}:00`;
        };

        let fechaInicioProgramada = null;
        let fechaFinProgramada = null;

        if (tramosCompletos.length > 0) {
          const primerTramo = tramosCompletos[0];
          const ultimoTramo = tramosCompletos[tramosCompletos.length - 1];

          // ✅ Fecha inicio: llegada al origen del primer tramo
          if (primerTramo.fechaLlegadaOrigen && primerTramo.horaLlegadaOrigen) {
            fechaInicioProgramada = combinarFechaHora(
              primerTramo.fechaLlegadaOrigen,
              primerTramo.horaLlegadaOrigen,
            );
          }

          // ✅ Fecha fin: llegada al destino del último tramo
          // CAMBIO: Usar horaLlegadaProgramada en lugar de horaSalidaProgramada
          if (ultimoTramo.fechaSalidaDestino && ultimoTramo.horaSalidaDestino) {
            fechaFinProgramada = combinarFechaHora(
              ultimoTramo.fechaSalidaDestino,
              ultimoTramo.horaSalidaDestino,
            );
          }
        }

        console.log("DATOS DEL VIAJE A ENVIAR:", {
          transportistaId: formData.transportistaId,
          operadorLogisticoId: formData.operadorLogisticoId,
          clienteId: formData.clienteId,
          camionId: formData.camionId,
          chasisId: formData.chasisId,
          choferId: formData.choferId,
          tipoOperacion: formData.tipoOperacion,
          tramosCompletos: tramosCompletos.length,
        });

        const viajeData = {
          empresaTransportista: { id: formData.transportistaId },
          empresaOperador: { id: formData.operadorLogisticoId },
          empresaCliente: { id: formData.clienteId },
          vehiculo: { id: formData.camionId },
          carreta: { id: formData.chasisId },
          conductor: { id: formData.choferId },
          tipoOperacion: formData.tipoOperacion,
          fechaInicioProgramada: fechaInicioProgramada,
          fechaFinProgramada:
            fechaFinProgramada || formData.fechaFinProgramada || null,
          observaciones: formData.observaciones || "",
        };

        if (formData.navieraId && formData.navieraId.trim() !== "") {
          viajeData.empresaNaviera = { id: formData.navieraId };
        }

        if (formData.codigoViaje && formData.codigoViaje.trim() !== "") {
          viajeData.codigoViaje = formData.codigoViaje.trim();
        }

        if (formData.contenedor && formData.contenedor.trim() !== "") {
          viajeData.contenedor = formData.contenedor.trim();
        }

        const viajeResponse = await fetch(`${API_LARAVEL_URL}/viajes`, {
          method: "POST",
          headers: getApiHeaders(),
          body: JSON.stringify(viajeData),
        });

        const viajeResponseText = await viajeResponse.text();

        let viajeResponseData = null;

        if (viajeResponseText && viajeResponseText.trim() !== "") {
          try {
            viajeResponseData = JSON.parse(viajeResponseText);
          } catch (parseError) {
            console.error("❌ ERROR PARSEANDO JSON:", parseError.message);
          }
        }

        const isSuccess =
          viajeResponse.status === 200 || viajeResponse.status === 201;
        const hasId =
          viajeResponseData &&
          (viajeResponseData.id ||
            viajeResponseData.data?.id ||
            viajeResponseData.viajeId ||
            (viajeResponseData.success === true && viajeResponseData.data));

        if (isSuccess && hasId) {
          const viajeId =
            viajeResponseData.id ||
            viajeResponseData.data?.id ||
            viajeResponseData.viajeId ||
            (viajeResponseData.data && viajeResponseData.data.id);
        let tramosCreados = 0;
          // Solo crear tramos si hay tramos completos
         if (tramosCompletos.length > 0) {
          const tramosPromises = tramosCompletos.map((tramo, i) => {
            const tramoData = {
              viajeId: viajeId,
              orden: i + 1,
              establecimientoOrigenId: tramo.origen.establecimientoId,
              establecimientoDestinoId: tramo.destino.establecimientoId,
              tipoActividad: tramo.tipoActividad,
              descripcion:
                tramo.descripcion ||
                `${tramo.tipoActividad} - Tramo ${i + 1}`,
              horaLlegadaProgramada: combinarFechaHora(
                tramo.fechaLlegadaOrigen,
                tramo.horaLlegadaOrigen,
              ),
              horaSalidaProgramada: combinarFechaHora(
                tramo.fechaSalidaDestino,
                tramo.horaSalidaDestino,
              ),
              slaMinutos: 30,
              observaciones: tramo.observaciones || null,
              vehiculoId: formData.camionId,
              carretaId: formData.chasisId,
              conductorId: formData.choferId,
            };
        
            return fetch(`${API_LARAVEL_URL}/tramos`, {
              method: "POST",
              headers: getApiHeaders(),
              body: JSON.stringify(tramoData),
            }).then((res) => {
              console.log(`📡 Tramo ${i + 1} status:`, res.status);
              return res;
            }).catch((err) => {
              console.error(`Error conexión tramo ${i + 1}:`, err);
              return null;
            });
          });
        
          const tramosResponses = await Promise.all(tramosPromises);
          tramosCreados = tramosResponses.filter(
            (r) => r && (r.ok || r.status === 201)
          ).length;
        }

          const codigoMostrar = formData.codigoViaje || "sin código";
          const mensajeExito =
            tramosCreados > 0
              ? `El viaje con código ${codigoMostrar} se ha guardado exitosamente con ${tramosCreados} tramo(s).`
              : `El viaje con código ${codigoMostrar} se ha guardado exitosamente.`;

          showAlertSwal("success", "Viaje Creado", mensajeExito, () => {
            setShowCreateForm(false);
            fetchViajesLista();
          });
        } else if (isSuccess && !hasId) {
          showAlertSwal(
            "warning",
            "Viaje Posiblemente Creado",
            "El viaje podría haberse creado correctamente. Por favor, verifique la lista de viajes.",
            () => {
              setShowCreateForm(false);
              fetchViajes();
            },
          );
        } else {
          showAlertSwal(
            "error",
            "Error al Guardar Viaje",
            "No se pudo guardar el viaje.",
          );
        }
      }
    } catch (error) {
      console.error("❌ ERROR GENERAL:", error);
      showAlertSwal("error", "Error de Conexión", `Error: ${error.message}`);
    } finally {
      setIsSaving(false);
      setLoadingMessage("");
    }
  };
  useEffect(() => {
    if (selectedViaje) {
      setVehiculosDisponibles([selectedViaje.vehiculo]);
      setCarretasDisponibles([selectedViaje.carreta]);
      setConductoresDisponibles([selectedViaje.conductor]);

      const numTramos = selectedViaje.tramos?.length || 0;
      setIsPrimerTramo(numTramos === 0);

      // No sobreescribir si estamos editando un tramo existente
      if (editTramoId) return;

      if (numTramos > 0) {
        // Heredar del último tramo
        const ultimoTramo = selectedViaje.tramos[numTramos - 1];
        setNuevoTramo((prev) => ({
          ...prev,
          tractoId:    ultimoTramo.tracto    || selectedViaje.vehiculo?.id  || "",
          chasisId:    ultimoTramo.chasis    || selectedViaje.carreta?.id   || "",
          conductorId: ultimoTramo.conductor?.id || ultimoTramo.conductor || selectedViaje.conductor?.id || "",
        }));
      } else {
        // 1er tramo: hereda directamente del viaje (sin editar)
        setNuevoTramo((prev) => ({
          ...prev,
          tractoId:    selectedViaje.vehiculo?.id   || "",
          chasisId:    selectedViaje.carreta?.id    || "",
          conductorId: selectedViaje.conductor?.id  || "",
        }));
      }
    }
  }, [selectedViaje, showTramosModal, editTramoId]);

  // Paginación
  const totalPages = Math.ceil(filteredViajes.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentViajes = filteredViajes.slice(
    startIndex,
    startIndex + itemsPerPage,
  );

  const handleCreateViaje = async () => {
  setIsEditMode(false);
  setEditingViajeId(null);

  // ✅ Cargar catálogo solo si aún no se ha cargado
  if (camiones.length === 0) {
    if (userRole === "transportista") {
      await loadTransportistaData(user.empresa_id);
    } else if (userRole === "operador_logistico") {
      await loadOperadorData(user.empresa_id);
    }
  }

  const formatLocalDateTime = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const formatLocalDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const formatLocalTime = (date) => {
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  const ahora = new Date();
  const dosHorasDespues = new Date(ahora.getTime() + 2 * 60 * 60 * 1000);
  const manana = new Date(ahora);
  manana.setDate(manana.getDate() + 1);

  setSelectedViaje(null);
  setFormData({
    tipoOperacion: "exportacion",
    codigoViaje: "",
    contenedor: "",
    transportistaId: userRole === "transportista" ? user?.empresa_id || "" : "",
    operadorLogisticoId: userRole === "operador_logistico" ? user?.empresa_id || "" : "",
    camionId: "",
    chasisId: "",
    choferId: "",
    clienteId: userRole === "cliente" ? user?.empresa_id || "" : "",
    origen: {
      tipo: "almacen",
      nombre: "",
      direccion: "",
      coordenadas: { lat: "", lng: "" },
    },
    destino: {
      tipo: "planta",
      nombre: "",
      direccion: "",
      coordenadas: { lat: "", lng: "" },
    },
    fechaInicio: formatLocalDateTime(ahora),
    fechaEstimadaFin: formatLocalDateTime(manana),
    observaciones: "",
    tramos: [
      {
        origen: { establecimientoId: "", nombre: "", tipo: "" },
        destino: { establecimientoId: "", nombre: "", tipo: "" },
        estado: "pendiente",
        tipoActividad: "recojo",
        fechaLlegadaOrigen: formatLocalDate(ahora),
        horaLlegadaOrigen: formatLocalTime(ahora),
        fechaSalidaDestino: formatLocalDate(dosHorasDespues),
        horaSalidaDestino: formatLocalTime(dosHorasDespues),
        observaciones: "",
      },
    ],
  });
  setShowCreateForm(true);
};

 const handleViewViaje = (viaje) => {
  fetchViajeDetalle(viaje.id);
};

  const handleNavieraChange = (navieraId) => {
    const almacenesPublicos = establecimientos.filter(
      (est) => est.tipo === "ALMACEN" && est.publico && est.activo,
    );

    setEstablecimientosFiltrados(almacenesPublicos);

    setFormData((prev) => ({
      ...prev,
      navieraId: navieraId,
    }));
  };

  const getEstablecimientosFiltrados = (tipoActividad, origenODestino) => {
    if (formData.tipoOperacion === "exportacion") {
      if (origenODestino === "origen") {
        if (establecimientosFiltrados.length > 0) {
          return establecimientosFiltrados;
        } else {
          return establecimientos.filter(
            (est) => est.tipo === "ALMACEN" && est.activo,
          );
        }
      }

      if (origenODestino === "destino") {
        const clienteId = formData.clienteId;

        if (!clienteId) {
          console.log("No hay cliente seleccionado");
          return [];
        }

        if (tipoActividad === "recojo") {
          const filtrados = establecimientos.filter((est) => {
            const cumple =
              est.tipo === "PLANTA" &&
              est.activo &&
              !est.publico &&
              est.empresaId === clienteId;
            return cumple;
          });

          console.log("✅ Plantas filtradas:", filtrados.length);
          return filtrados;
        } else if (tipoActividad === "recojo_anticipado") {
          return establecimientos.filter(
            (est) => est.tipo === "COCHERA" && est.activo && !est.publico,
          );
        } else if (tipoActividad === "despacho_full") {
          return establecimientos.filter(
            (est) => est.tipo === "PUERTO" && est.activo && est.publico,
          );
        }
      }
    }

    // ✅ MODIFICACIÓN PARA IMPORTACIÓN
    if (formData.tipoOperacion === "importacion") {
      if (origenODestino === "origen") {
        // ORIGEN en importación: Puede ser ALMACEN (depósito) o PLANTA (origen de redistribución)
        return establecimientos.filter(
          (est) =>
            (est.tipo === "ALMACEN" || est.tipo === "PLANTA") && est.activo,
        );
      }

      if (origenODestino === "destino") {
        const clienteId = formData.clienteId;

        if (!clienteId) {
          return []; // Requiere cliente seleccionado
        }

        // DESTINO en importación: Puede ser ALMACEN o PLANTA del cliente
        return establecimientos.filter(
          (est) =>
            (est.tipo === "ALMACEN" || est.tipo === "PLANTA") &&
            est.activo &&
            (est.publico || // ALMACENes públicos
              (!est.publico && est.empresaId === clienteId)), // PLANTAs del cliente
        );
      }
    }

    return establecimientos.filter((est) => est.publico && est.activo);
  };

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortDirection("asc");
    }
  };

  const getSortIcon = (field) => {
    if (sortField !== field) {
      return <ArrowRight className="h-3 w-3 text-gray-400 rotate-90" />;
    }
    return sortDirection === "asc" ? (
      <ArrowRight className="h-3 w-3 text-gray-600 -rotate-90" />
    ) : (
      <ArrowRight className="h-3 w-3 text-gray-600 rotate-90" />
    );
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedViaje(null);
  };

  const getStatusColor = (estado) => {
    switch (estado) {
      case "pendiente":
        return "bg-blue-100 text-blue-800";
      case "en_transito":
        return "bg-yellow-100 text-yellow-800";
      case "completado":
        return "bg-green-100 text-green-800";
      case "cancelado":
        return "bg-red-100 text-red-800";
      case "retrasado":
        return "bg-orange-100 text-orange-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  const getStatusIcon = (estado) => {
    switch (estado) {
      case "pendiente":
        return <Clock className="h-4 w-4" />;
      case "en_transito":
        return <Play className="h-4 w-4" />;
      case "completado":
        return <CheckCircle className="h-4 w-4" />;
      case "cancelado":
        return <Square className="h-4 w-4" />;
      case "retrasado":
        return <AlertCircle className="h-4 w-4" />;
      default:
        return <Pause className="h-4 w-4" />;
    }
  };

  const getDestinosPermitidos = (tipoOperacion) => {
    if (tipoOperacion === "exportacion") {
      return [
        { value: "planta", label: "Planta (Cliente)" },
        { value: "puerto", label: "Puerto" },
      ];
    } else {
      return [
        { value: "almacen", label: "Almacén" },
        { value: "planta", label: "Planta (Cliente)" },
      ];
    }
  };

  const getOrigenesPermitidos = (tipoOperacion) => {
    if (tipoOperacion === "exportacion") {
      return [{ value: "almacen", label: "Almacén" }];
    } else {
      return [
        { value: "almacen", label: "Almacén" },
        { value: "puerto", label: "Puerto" },
      ];
    }
  };

  const getProgressPercentage = (estado) => {
    switch (estado) {
      case "pendiente":
        return 25;
      case "en_transito":
        return 75;
      case "completado":
        return 100;
      case "cancelado":
        return 0;
      default:
        return 0;
    }
  };


  const handleStatusChange = async (newStatus, tramoId) => {
    try {
      console.log(`Cambiando estado real del tramo a: ${newStatus}`);

      // 1. Enviar al backend (dispara el Observer)
      const response = await fetch(`${API_LARAVEL_URL}/tramos/${tramoId}`, {
        method: "PUT",
        headers: getApiHeaders(),
        body: JSON.stringify({
          estado: newStatus,
        }),
      });

      const data = await response.json();

      if (!data.success) {
        return showAlertSwal("error", "Error", data.message);
      }

      // 2. Recargar el viaje actualizado desde backend
      fetchViajes(selectedViaje.id);

      showAlertSwal(
        "success",
        "Actualizado",
        "El estado fue actualizado correctamente",
      );
    } catch (err) {
      console.error("Error:", err);
      showAlertSwal("error", "Error", "No se pudo cambiar el estado");
    }
  };

  const toLocalDatetimeInput = (dateStr) => {
    const d = new Date(dateStr);
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
  };

  const toLocalDateInput = (dateStr) => {
    const d = new Date(dateStr);
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  };

  const toLocalTimeInput = (dateStr) => {
    const d = new Date(dateStr);
    const pad = (n) => String(n).padStart(2, "0");
    return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
  };

  const handleEditViaje = async (viaje) => {
  if (viaje.estado !== "pendiente") {
    showAlertSwal(
      "warning",
      "No Editable",
      "Solo se pueden editar viajes en estado pendiente.",
    );
    return;
  }

  // ✅ Cargar detalle completo antes de abrir el formulario
  setLoading(true);
  setLoadingMessage("Cargando datos del viaje...");

  try {
    const res = await fetch(
      `${API_LARAVEL_URL}/viajes/${viaje.id}`,
      { headers: getApiHeaders() }
    );
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const detalle = await res.json();

    // A partir de aquí todo igual que antes pero usando "detalle" en vez de "viaje"
    setSelectedViaje(detalle);
    setIsEditMode(true);
    setEditingViajeId(detalle.id);

    setFormData({
      tipoOperacion: detalle.tipoOperacion || "exportacion",
      transportistaId: detalle.empresaTransportista?.id || "",
      operadorLogisticoId: detalle.empresaOperador?.id || "",
      codigoViaje: detalle.codigoViaje || "",
      contenedor: detalle.contenedor || "",
      navieraId: detalle.empresaNaviera?.id || "",
      camionId: detalle.vehiculo?.id || "",
      chasisId: detalle.carreta?.id || "",
      choferId: detalle.conductor?.id || "",
      clienteId: detalle.empresaCliente?.id || "",
      observaciones: detalle.observaciones || "",
      fechaInicio: detalle.fechaInicioProgramada
        ? toLocalDatetimeInput(detalle.fechaInicioProgramada)
        : "",
      fechaEstimadaFin: detalle.fechaFinProgramada
        ? toLocalDatetimeInput(detalle.fechaFinProgramada)
        : "",
      fechaFinProgramada: detalle.fechaFinProgramada
        ? toLocalDatetimeInput(detalle.fechaFinProgramada)
        : "",
      tramos: (detalle.tramos || []).map((tramo, index) => ({
        id: tramo.id,
        orden: tramo.orden || index + 1,
        origen: {
          establecimientoId: tramo.establecimientoOrigen?.id || "",
          nombre: tramo.establecimientoOrigen?.nombre || "",
          tipo: tramo.establecimientoOrigen?.tipo || "",
        },
        destino: {
          establecimientoId: tramo.establecimientoDestino?.id || "",
          nombre: tramo.establecimientoDestino?.nombre || "",
          tipo: tramo.establecimientoDestino?.tipo || "",
        },
        tipoActividad: tramo.tipoActividad || "",
        estado: tramo.estado || "pendiente",
        fechaLlegadaOrigen: tramo.horaLlegadaProgramada
          ? toLocalDateInput(tramo.horaLlegadaProgramada)
          : "",
        horaLlegadaOrigen: tramo.horaLlegadaProgramada
          ? toLocalTimeInput(tramo.horaLlegadaProgramada)
          : "",
        fechaSalidaDestino: tramo.horaSalidaProgramada
          ? toLocalDateInput(tramo.horaSalidaProgramada)
          : "",
        horaSalidaDestino: tramo.horaSalidaProgramada
          ? toLocalTimeInput(tramo.horaSalidaProgramada)
          : "",
        observaciones: tramo.observaciones || "",
        descripcion: tramo.descripcion || "",
      })),
    });

    setShowCreateForm(true);

  } catch (err) {
    showAlertSwal("error", "Error", "No se pudieron cargar los datos del viaje.");
  } finally {
    setLoading(false);
    setLoadingMessage("");
  }
};

  const handleDeleteViaje = (viajeId) => {
    if (window.confirm("¿Estás seguro de que deseas eliminar este viaje?")) {
      setViajes((prev) => prev.filter((v) => v.id !== viajeId));
    }
  };

  const deleteViaje = async (viaje) => {
    try {
      // Confirmación con SweetAlert
      const confirmResult = await Swal.fire({
        title: "¿Confirmar eliminación?",
        html: `
          <div class="text-left">
            <p><strong>Viaje:</strong> ${viaje.codigoViaje || "Sin código"}</p>
            <p><strong>Estado:</strong> ${viaje.estado}</p>
            <p><strong>Transportista:</strong> ${viaje.empresaTransportista?.nombre || "N/A"
          }</p>
            <p class="text-red-600 mt-3">⚠️ Esta acción no se puede deshacer</p>
            <p class="text-red-600">Se eliminarán también todos los tramos asociados</p>
          </div>
        `,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
        reverseButtons: true,
      });

      if (!confirmResult.isConfirmed) {
        return; // Usuario canceló
      }

      // Mostrar loading durante eliminación
      setIsDeleting(true);
      setLoadingMessage("Eliminando viaje...");

      console.log("🗑️ Eliminando viaje:", viaje.id);

      const response = await fetch(`${API_LARAVEL_URL}/viajes/${viaje.id}`, {
        method: "DELETE",
        headers: getApiHeaders(),
      });

      const responseText = await response.text();
      console.log("📡 Respuesta eliminación:", responseText);

      let responseData = null;
      if (responseText && responseText.trim() !== "") {
        try {
          responseData = JSON.parse(responseText);
        } catch (parseError) {
          console.error("❌ Error parseando respuesta:", parseError);
        }
      }

      if (response.ok || response.status === 200) {
        console.log("✅ Viaje eliminado exitosamente");

        await Swal.fire({
          title: "Eliminado",
          text: `El viaje ${viaje.codigoViaje || "sin código"
            } ha sido eliminado exitosamente.`,
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        });

        setShowTramosModal(false);
        await fetchViajesLista(fechaDesde, fechaHasta);
      } else {
        console.error("❌ Error al eliminar:", response.status);

        let errorMessage = "No se pudo eliminar el viaje.";

        if (response.status === 404) {
          errorMessage = "El viaje ya no existe.";
        } else if (responseData?.message) {
          errorMessage = responseData.message;
        }

        Swal.fire({
          title: "Error",
          text: errorMessage,
          icon: "error",
        });
      }
    } catch (error) {
      console.error("❌ Error al eliminar viaje:", error);

      Swal.fire({
        title: "Error de Conexión",
        text: `Error al conectar con el servidor: ${error.message}`,
        icon: "error",
      });
    } finally {
      setIsDeleting(false);
      setLoadingMessage("");
    }
  };

  const calculateDropdownPosition = (buttonElement) => {
    if (!buttonElement) return "bottom";

    const rect = buttonElement.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const dropdownHeight = 320;
    const spaceBelow = windowHeight - rect.bottom;
    const spaceAbove = rect.top;

    if (spaceBelow < dropdownHeight && spaceAbove > dropdownHeight) {
      return "top";
    }

    return "bottom";
  };

  const buttonRefs = useRef({});
  const isInitialized = useRef(false);
  const vehiculosCache = useRef({});
    
  const handleButtonClick = (viajeId) => {
    const buttonElement = buttonRefs.current[viajeId];
    if (buttonElement) {
      const position = calculateDropdownPosition(buttonElement);
      setDropdownPositions((prev) => ({
        ...prev,
        [viajeId]: position,
      }));
    }

    toggleDropdown(viajeId);
  };

  const toggleDropdown = (viajeId) => {
    setShowDropdown((prev) => ({
      ...prev,
      [viajeId]: !prev[viajeId],
    }));
  };

  const closeAllDropdowns = () => {
    setShowDropdown({});
  };

  const handleEvidenciaSelectFromDropdown = (setNumber, viaje) => {
    handleEvidenciaSelect(setNumber, viaje);
    closeAllDropdowns();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".dropdown-container")) {
        closeAllDropdowns();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  // Paginación
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const updateTramo = (index, campo, subcampo, valor) => {
    const nuevosTramos = [...formData.tramos];

    if (subcampo === "") {
      nuevosTramos[index][campo] = valor;
    } else {
      if (!nuevosTramos[index][campo]) {
        nuevosTramos[index][campo] = {};
      }
      nuevosTramos[index][campo][subcampo] = valor;
    }

    setFormData({ ...formData, tramos: nuevosTramos });
  };

  const addTramo = () => {
    const fechasDefecto = obtenerFechasDefecto();
    const tramosActuales = formData.tramos || [];
    const tramoAnterior = tramosActuales[tramosActuales.length - 1];
    const numeroTramo = tramosActuales.length + 1;

    const origenNuevo = {
      establecimientoId: tramoAnterior?.destino?.establecimientoId || "",
      nombre: tramoAnterior?.destino?.nombre || "",
      tipo: tramoAnterior?.destino?.tipo || "",
    };

    let nuevoTramo = {
      origen: origenNuevo,
      destino: { establecimientoId: "", nombre: "", tipo: "" },
      estado: "pendiente",
      tipoActividad: "",
      fechaLlegadaOrigen: fechasDefecto.fechaActual,
      horaLlegadaOrigen: fechasDefecto.horaActual,
      fechaSalidaDestino: fechasDefecto.fechaDosHoras,
      horaSalidaDestino: fechasDefecto.horaDosHoras,
      observaciones: "",
    };

    if (tramosActuales.length > 0) {
      const primerTramo = tramosActuales[0];
      const tipoActividadPrimero = primerTramo.tipoActividad;

      if (numeroTramo === 2) {
        if (tipoActividadPrimero === "recojo") {
          nuevoTramo.tipoActividad = "despacho_full";

          const puertos = establecimientos.filter(
            (est) => est.tipo === "PUERTO" && est.activo,
          );
          if (puertos.length > 0) {
            const puerto = puertos[0];
            nuevoTramo.destino = {
              establecimientoId: puerto.id,
              nombre: puerto.nombre,
              tipo: puerto.tipo,
            };
          }
        } else if (tipoActividadPrimero === "recojo_anticipado") {
          nuevoTramo.tipoActividad = "entrega_planta";

          const plantas = establecimientos.filter(
            (est) => est.tipo === "PLANTA" && est.activo && !est.publico,
          );
          if (plantas.length > 0) {
            const planta = plantas[0];
            nuevoTramo.destino = {
              establecimientoId: planta.id,
              nombre: planta.nombre,
              tipo: planta.tipo,
            };
          }
        }
      } else if (numeroTramo === 3) {
        if (tipoActividadPrimero === "recojo") {
          showAlertSwal(
            "warning",
            "Tramo No Permitido",
            'No se puede agregar un tercer tramo cuando el primer tramo es de tipo "Recojo". El flujo termina en el puerto.',
          );
          return;
        } else if (tipoActividadPrimero === "recojo_anticipado") {
          nuevoTramo.tipoActividad = "despacho_full";

          const puertos = establecimientos.filter(
            (est) => est.tipo === "PUERTO" && est.activo,
          );
          if (puertos.length > 0) {
            const puerto = puertos[0];
            nuevoTramo.destino = {
              establecimientoId: puerto.id,
              nombre: puerto.nombre,
              tipo: puerto.tipo,
            };
          }
        }
      } else if (numeroTramo > 3) {
        showAlertSwal(
          "warning",
          "Límite de Tramos",
          "No se pueden agregar más de 3 tramos por viaje.",
        );
        return;
      }
    }

    setFormData((prev) => ({
      ...prev,
      tramos: [...prev.tramos, nuevoTramo],
    }));

    console.log(`✅ Tramo ${numeroTramo} agregado:`, nuevoTramo);
  };

  const removeTramo = (index) => {
    if (formData.tramos.length > 1) {
      const nuevosTramos = formData.tramos.filter((_, i) => i !== index);
      setFormData({ ...formData, tramos: nuevosTramos });
    }
  };

  console.log("🔍 ESTADO ACTUAL EN RENDER:", {
    camiones,
    esArray: Array.isArray(camiones),
    cantidad: camiones?.length,
    tieneNulos: camiones?.some((c) => c == null),
    userRole,
    loading,
  });

  const camionesSeguros = (camiones || []).filter(
    (camion) =>
      camion && typeof camion === "object" && camion.placa && camion.id,
  );

  const handleEvidenciaSelect = async (setNumber, viaje) => {
    if (!setNumber) return;

    const selectedSet = evidenciasSets[setNumber];
    setActiveEvidenciaSetKey(setNumber);
    setSelectedHito(selectedSet.hito);
    setEvidenciasViaje(viaje);

    setShowEvidenciasModal(true);
    setLoadingEvidencias(true);

    await loadEvidencias(viaje.id, selectedSet.hito);
    setLoadingEvidencias(false);
  };

  const loadEvidencias = async (viajeId, hito) => {
    try {
      const response = await fetch(
        `${API_LARAVEL_URL}/evidencias-viajes/viaje/${viajeId}`,
        { headers: getApiHeaders() },
      );

      if (response.ok) {
        const todasEvidencias = await response.json();
        setAllEvidencias(todasEvidencias);

        const evidenciasHito = todasEvidencias.filter((ev) => ev.hito === hito);
        setEvidenciasList(evidenciasHito);
      }
    } catch (error) {
      console.error("Error cargando evidencias:", error);
      setAllEvidencias([]);
      setEvidenciasList([]);
    }
  };
  // Función para seleccionar archivo y mostrar preview
  const handleFileSelect = (secuencia) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.onchange = async (e) => {
      const file = e.target.files[0];
      if (file) {
        // Validar tamaño (opcional, máx 5MB)
        if (file.size > 5 * 1024 * 1024) {
          showAlertSwal(
            "error",
            "Archivo muy grande",
            "El archivo no debe superar 5MB",
          );
          return;
        }

        // Crear preview
        const reader = new FileReader();
        reader.onload = (event) => {
          setPreviewImage({
            file: file,
            dataUrl: event.target.result,
            secuencia: secuencia,
            nombre: file.name,
            tipo: file.type,
            tamanio: file.size,
          });
          setShowPreviewModal(true);
        };
        reader.readAsDataURL(file);
      }
    };
    input.click();
  };

  const handleEvidenciaTabChange = async (setKey) => {
    if (setKey === activeEvidenciaSetKey) return;
    const setInfo = evidenciasSets[setKey];
    setActiveEvidenciaSetKey(setKey);
    setSelectedHito(setInfo.hito);
    setLoadingEvidencias(true);
    if (allEvidencias.length) {
      const evidenciasHito = allEvidencias.filter((ev) => ev.hito === setInfo.hito);
      setEvidenciasList(evidenciasHito);
      setLoadingEvidencias(false);
    } else {
      await loadEvidencias(evidenciasViaje.id, setInfo.hito);
      setLoadingEvidencias(false);
    }
  };

  const getSetStatus = (key) => {
    const set = evidenciasSets[key];
    if (!set || !allEvidencias.length) return { total: set?.fotos?.length || 0, completed: 0, status: "pending" };
    const setEvids = allEvidencias.filter((ev) => ev.hito === set.hito);
    const completed = setEvids.length;
    const total = set.fotos.length;
    if (completed === 0) return { total, completed, status: "pending" };
    if (completed >= total) return { total, completed, status: "complete" };
    return { total, completed, status: "partial" };
  };

  // Función para confirmar y subir
  const confirmarYSubirEvidencia = async () => {
    if (!previewImage) return;

    setShowPreviewModal(false);
    await uploadEvidencia(previewImage.file, previewImage.secuencia);
    setPreviewImage(null);
  };

  // Función para cancelar
  const cancelarPreview = () => {
    setShowPreviewModal(false);
    setPreviewImage(null);
  };
  const uploadEvidencia = async (file, secuencia) => {
  if (!file || !evidenciasViaje) return;
  setUploading(true);

  try {
    const base64 = await fileToBase64(file);

    const evidenciaData = {
      viajeId:       evidenciasViaje.id,
      hito:          selectedHito,
      secuencia:     secuencia,
      tipoAdjunto:   file.type.startsWith("image/") ? "IMAGEN" : "PDF",
      archivo:       base64.split(",")[1],   // solo la parte base64 sin prefijo
      nombreArchivo: file.name,
      contentType:   file.type,
    };

    const response = await fetch(`${API_LARAVEL_URL}/evidencias-viajes`, {
      method: "POST",
      headers: getApiHeaders(),              // ← incluye Bearer token
      body: JSON.stringify(evidenciaData),
    });

    if (response.ok) {
      showAlertSwal("success", "Evidencia Subida", "La evidencia se ha guardado correctamente.");
      await loadEvidencias(evidenciasViaje.id, selectedHito);
    } else {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData?.message || errorData?.error || `Error ${response.status}`);
    }
  } catch (error) {
    showAlertSwal("error", "Error", "No se pudo subir la evidencia: " + error.message);
  } finally {
    setUploading(false);
  }
};
  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const deleteEvidencia = async (secuencia) => {
  showConfirmModal(
    "Confirmar eliminación",
    "¿Estás seguro de que deseas eliminar esta evidencia? Esta acción no se puede deshacer.",
    async () => {
      try {
        const response = await fetch(`${API_LARAVEL_URL}/evidencias-viajes`, {
          method: "DELETE",
          headers: getApiHeaders(),            // ← incluye Bearer token
          body: JSON.stringify({
            idViaje:   evidenciasViaje.id,
            hito:      selectedHito,
            secuencia: secuencia,
          }),
        });

        if (response.ok) {
          showAlertSwal("success", "Evidencia Eliminada", "La evidencia se ha eliminado correctamente.");
          await loadEvidencias(evidenciasViaje.id, selectedHito);
        } else {
          throw new Error("Error al eliminar evidencia");
        }
      } catch (error) {
        showAlertSwal("error", "Error", "No se pudo eliminar la evidencia: " + error.message);
      }
    }
  );
};

  const capturePhoto = (secuencia) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.capture = "environment";
    input.onchange = (e) => {
      const file = e.target.files[0];
      if (file) {
        uploadEvidencia(file, secuencia);
      }
    };
    input.click();
  };

  const handleEditTramo = (tramo) => {
    const ajustarZonaHoraria = (fechaISO) => {
      const fecha = new Date(fechaISO);
      const offsetMinutos = fecha.getTimezoneOffset();
      return new Date(fecha.getTime() - offsetMinutos * 60000);
    };

    const fechaHoraLlegada = tramo.horaLlegadaProgramada
      ? ajustarZonaHoraria(tramo.horaLlegadaProgramada)
      : null;
    const fechaHoraSalida = tramo.horaSalidaProgramada
      ? ajustarZonaHoraria(tramo.horaSalidaProgramada)
      : null;

    const nuevoTramoData = {
      tractoId: tramo.tracto || "",
      chasisId: tramo.chasis || "",

      conductorId: tramo.conductor?.id || tramo.conductor || "",
      origen: {
        establecimientoId: tramo.establecimientoOrigen?.id || "",
        nombre: tramo.establecimientoOrigen?.nombre || "",
        tipo: tramo.establecimientoOrigen?.tipo || "",
      },
      destino: {
        establecimientoId: tramo.establecimientoDestino?.id || "",
        nombre: tramo.establecimientoDestino?.nombre || "",
        tipo: tramo.establecimientoDestino?.tipo || "",
      },
      tipoActividad: tramo.tipoActividad || "",
      fechaLlegadaOrigen: fechaHoraLlegada
        ? fechaHoraLlegada.toISOString().split("T")[0]
        : "",
      horaLlegadaOrigen: fechaHoraLlegada
        ? fechaHoraLlegada.toISOString().split("T")[1]?.slice(0, 5)
        : "",
      fechaSalidaDestino: fechaHoraSalida
        ? fechaHoraSalida.toISOString().split("T")[0]
        : "",
      horaSalidaDestino: fechaHoraSalida
        ? fechaHoraSalida.toISOString().split("T")[1]?.slice(0, 5)
        : "",
      observaciones: tramo.observaciones || "",
    };

    if (!vehiculosDisponibles.length) fetchVehiculos();
    if (!carretasDisponibles.length) fetchCarretas();
    if (!conductoresDisponibles.length) fetchConductores();
    if (!establecimientos.length) fetchEstablecimientos();

    setNuevoTramo(nuevoTramoData);
    setEditTramoId(tramo.id);
    setShowTramosModal(true);
  };

  const handleDeleteTramo = async (tramo) => {
    Swal.fire({
      title: "¿Eliminar tramo?",
      text: `¿Deseas eliminar el tramo ${tramo.orden || ""} (${tramo.tipoActividad || ""
        })? Esta acción no se puede deshacer.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await fetch(
            `${API_LARAVEL_URL}/tramos/${tramo.id}`,
            {
              method: "DELETE",
              headers: getApiHeaders(),
            },
          );

          const text = await response.text();
          const data = text ? JSON.parse(text) : null;

          if (response.ok && data?.success) {
            await fetchViajesLista();

            const viajeActualizado = await fetch(
              `${API_LARAVEL_URL}/viajes/${selectedViaje.id}`,
              {
                headers: getApiHeaders(),
              },
            ).then((res) => res.json());

            setSelectedViaje(viajeActualizado);

            Swal.fire({
              icon: "success",
              title: "Tramo eliminado",
              text: "El tramo fue eliminado correctamente.",
              timer: 2000,
              showConfirmButton: false,
            });
          } else {
            Swal.fire(
              "Error",
              data?.message || "No se pudo eliminar el tramo.",
              "error",
            );
          }
        } catch (error) {
          console.error("❌ Error al eliminar tramo:", error);
          Swal.fire(
            "Error de conexión",
            "No se pudo conectar con el servidor.",
            "error",
          );
        }
      }
    });
  };

  const agregarTramo = async () => {
    try {
      setIsSavingTramo(true);

      // ✅ Validaciones existentes
      if (!nuevoTramo.destino.establecimientoId) {
        showAlertSwal(
          "error",
          "Campo Requerido",
          "Debe seleccionar un establecimiento de destino.",
        );
        return;
      }

      if (!nuevoTramo.tipoActividad) {
        showAlertSwal(
          "error",
          "Campo Requerido",
          "Debe seleccionar un tipo de actividad.",
        );
        return;
      }

      if (
        nuevoTramo.origen.establecimientoId ===
        nuevoTramo.destino.establecimientoId
      ) {
        showAlertSwal(
          "error",
          "Tramo Inválido",
          "El origen y destino no pueden ser el mismo establecimiento.",
        );
        return;
      }

      const combinarFechaHora = (fecha, hora) => {
        if (!fecha || !hora) return null;
        return `${fecha}T${hora}:00`;
      };

      const tramoData = {
        viajeId: selectedViaje.id,
        vehiculoId: nuevoTramo.tractoId,
        carretaId: nuevoTramo.chasisId,
        conductorId: nuevoTramo.conductorId,
        orden: (selectedViaje.tramos?.length || 0) + 1,
        establecimientoOrigenId:
          nuevoTramo.origen.establecimientoId ||
          (selectedViaje.tramos && selectedViaje.tramos.length > 0
            ? selectedViaje.tramos[selectedViaje.tramos.length - 1]
              .establecimientoDestinoId
            : null),
        establecimientoDestinoId: nuevoTramo.destino.establecimientoId,
        tipoActividad: nuevoTramo.tipoActividad,
        estado: nuevoTramo.estado || "pendiente",
        descripcion:
          nuevoTramo.observaciones ||
          `${nuevoTramo.tipoActividad} - Tramo ${(selectedViaje.tramos?.length || 0) + 1
          }`,
        horaLlegadaProgramada: combinarFechaHora(
          nuevoTramo.fechaLlegadaOrigen,
          nuevoTramo.horaLlegadaOrigen,
        ),
        horaSalidaProgramada: combinarFechaHora(
          nuevoTramo.fechaSalidaDestino,
          nuevoTramo.horaSalidaDestino,
        ),
        slaMinutos: 30,
        observaciones: nuevoTramo.observaciones || null,
      };

      const isEditing = !!editTramoId;
      const url = isEditing
        ? `${API_LARAVEL_URL}/tramos/${editTramoId}`
        : `${API_LARAVEL_URL}/tramos`;

      const method = isEditing ? "PUT" : "POST";

      const response = await fetch(url, {
        method,
        headers: getApiHeaders(),
        body: JSON.stringify(tramoData),
      });

      const responseText = await response.text();

      if (response.ok) {
        await fetchViajes();

        const viajesActualizados = await fetch(
          `${API_LARAVEL_URL}/viajes/${selectedViaje.id}`,
          {
            headers: getApiHeaders(),
          },
        ).then((res) => res.json());

        setSelectedViaje(viajesActualizados);

        const fechasDefecto = obtenerFechasDefecto();
        setNuevoTramo({
          origen: { establecimientoId: "", nombre: "", tipo: "" },
          destino: { establecimientoId: "", nombre: "", tipo: "" },
          estado: "pendiente",
          tipoActividad: "",
          fechaLlegadaOrigen: fechasDefecto.fechaActual,
          horaLlegadaOrigen: fechasDefecto.horaActual,
          fechaSalidaDestino: fechasDefecto.fechaDosHoras,
          horaSalidaDestino: fechasDefecto.horaDosHoras,
          observaciones: "",
          tractoId: "",
          chasisId: "",
          conductorId: "",
        });

        setEditTramoId(null);

        setShowTramosModal(false);

        showAlertSwal(
          "success",
          isEditing ? "Tramo Actualizado" : "Tramo Agregado",
          isEditing
            ? "El tramo se actualizó correctamente."
            : "El nuevo tramo se ha agregado exitosamente.",
        );
      } else {
        console.error(
          `❌ ERROR AL ${isEditing ? "ACTUALIZAR" : "CREAR"
          } TRAMO EN LARAVEL - Status:`,
          response.status,
        );
        console.error("❌ Respuesta:", responseText);

        let errorMessage = "No se pudo guardar el tramo.";
        try {
          const errorData = JSON.parse(responseText);
          errorMessage = errorData.message || errorData.error || errorMessage;
        } catch { }

        showAlertSwal(
          "error",
          `Error al ${isEditing ? "Actualizar" : "Agregar"} Tramo`,
          errorMessage,
        );
      }
    } catch (error) {
      console.error("❌ ERROR DE CONEXIÓN AL GUARDAR TRAMO:", error);
      showAlertSwal(
        "error",
        "Error de Conexión",
        `Error al conectar con el servidor Laravel: ${error.message}`,
      );
    } finally {
      setIsSavingTramo(false);
    }
  };

  const renderCreateForm = () => {
    if (!showCreateForm) return null;

    const opcionesChoferes = choferes.map((chofer) => ({
      value: chofer.id,
      label: `${chofer.apellidos} ${chofer.nombre} - Lic. ${chofer.licenciaCategoria}`,
    }));

    const opcionesNavieras = navieras
      .sort((a, b) =>
        (a.naviera.nombre || "").localeCompare(b.naviera.nombre || ""),
      )
      .map((navieraData) => ({
        value: navieraData.naviera.id,
        label: navieraData.naviera.nombre,
      }));

    const opcionesTransportistas = transportistas
      .sort((a, b) => (a.nombre || "").localeCompare(b.nombre || ""))
      .map((t) => ({
        value: t.id,
        label: t.nombre,
      }));

    const opcionesOperadores = operadoresLogisticos
      .sort((a, b) => (a.nombre || "").localeCompare(b.nombre || ""))
      .map((op) => ({
        value: op.id,
        label: op.nombre,
      }));

    const opcionesClientes = clientes
      .sort((a, b) => (a.nombre || "").localeCompare(b.nombre || ""))
      .map((cliente, index) => ({
        value: cliente.id,
        label: `${cliente.nombre}${cliente.ruc ? ` (${cliente.ruc})` : ""}`,
      }));

    // const opcionesCamiones = camionesSeguros
    //   .sort((a, b) => (a.placa || "").localeCompare(b.placa || ""))
    //   .map((camion) => {
    //     let label = camion.placa || "Sin placa";

    //     if (camion.marca || camion.modelo) {
    //       const marcaModelo = [camion.marca, camion.modelo]
    //         .filter(Boolean)
    //         .join(" ");
    //       if (marcaModelo) {
    //         label += ` - ${marcaModelo}`;
    //       }
    //     }

    //     if (camion.capacidadToneladas) {
    //       label += ` (${camion.capacidadToneladas}t)`;
    //     }

    //     return {
    //       value: camion.id,
    //       label: label,
    //     };
    //   });
    const opcionesCamiones = camionesSeguros
      .sort((a, b) => (a.placa || "").localeCompare(b.placa || ""))
      .map((camion) => ({
        value: camion.id,
        label: camion.placa || "Sin placa",
      }));
    const opcionesChasis = chasis
      .filter((carreta) => carreta && carreta.id && carreta.placa)
      .sort((a, b) => (a.placa || "").localeCompare(b.placa || ""))
      .map((carreta) => {
        let label = carreta.placa || "Sin placa";

        if (carreta.marca || carreta.modelo) {
          const marcaModelo = [carreta.marca, carreta.modelo]
            .filter(Boolean)
            .join(" ");
          if (marcaModelo) {
            label += ` - ${marcaModelo}`;
          }
        }

        if (carreta.capacidadToneladas) {
          label += ` (${carreta.capacidadToneladas}t)`;
        }

        return {
          value: carreta.id,
          label: label,
        };
      });

    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50 to-indigo-100">
        {/* Header del formulario */}
        <div className="bg-white shadow-sm border-b border-gray-200">
          <div className="px-4 py-3">
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <div
                  className={`p-2 rounded-lg mr-3 ${isEditMode
                    ? "bg-gradient-to-r from-amber-500 to-orange-600"
                    : "bg-gradient-to-r from-emerald-500 to-teal-600"
                    }`}
                >
                  <Package className="h-5 w-5 text-white" />
                </div>
                <div>
                  <h1 className="text-xl font-bold text-gray-900">
                    {isEditMode ? "Editar Viaje" : "Nuevo Viaje"}
                  </h1>
                  <p className="text-sm text-gray-600">
                    {isEditMode
                      ? `Modificando: ${formData.codigoViaje || "Sin código"} `
                      : "Complete la información para crear un nuevo viaje"}
                  </p>
                </div>
              </div>
              <div className="flex space-x-2">
                <button
                  onClick={() => {
                    setShowCreateForm(false);
                    setIsEditMode(false);
                    setEditingViajeId(null);
                  }}
                  className="px-4 py-2 text-gray-700 bg-gray-200 hover:bg-gray-300 rounded-lg font-medium transition-colors duration-200 text-sm"
                >
                  Cancelar
                </button>
                <button
                  onClick={saveViaje}
                  disabled={isSaving || loading}
                  className={`w-full py-3 px-4 rounded-lg font-medium transition duration-200 ${isSaving || loading
                    ? "bg-gray-400 text-gray-600 cursor-not-allowed"
                    : isEditMode
                      ? "bg-amber-600 text-white hover:bg-amber-700"
                      : "bg-blue-600 text-white hover:bg-blue-700"
                    }`}
                >
                  {isSaving ? (
                    <div className="flex items-center justify-center space-x-2">
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                      <span>
                        {isEditMode ? "Actualizando..." : "Guardando..."}
                      </span>
                    </div>
                  ) : isEditMode ? (
                    "Actualizar Viaje"
                  ) : (
                    "Guardar Viaje"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Formulario */}
        <div className="px-4 py-4">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
            <form className="space-y-4">
              {/* Configuración inicial */}
              <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">
                    Operación
                  </label>
                  <select
                    value={formData.tipoOperacion}
                    onChange={(e) => {
                      if (!isEditMode) {
                        setFormData({
                          ...formData,
                          tipoOperacion: e.target.value,
                        });
                      }
                    }}
                    disabled={isEditMode}
                    className={`select-fixed-height w-full px-2 py-1.5 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-emerald-500 focus:border-emerald-500 ${isEditMode
                      ? "bg-gray-100 text-gray-500 cursor-not-allowed"
                      : ""
                      }`}
                  >
                    <option value="exportacion">Exportación</option>
                    <option value="importacion">Importación</option>
                  </select>
                </div>

                {/* NAVIERA */}
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">
                    Naviera
                  </label>
                  <Select
                    options={opcionesNavieras}
                    value={
                      opcionesNavieras.find(
                        (opt) => opt.value === formData.navieraId,
                      ) || null
                    }
                    onChange={(opcion) => handleNavieraChange(opcion?.value)}
                    placeholder="Seleccionar naviera..."
                    isDisabled={navieras.length === 0}
                    className="text-sm"
                    styles={{
                      control: (base) => ({
                        ...base,
                        borderColor: isEditMode ? "#10b981" : "#d1d5db",
                        minHeight: "36px",
                        fontSize: "0.875rem",
                      }),
                    }}
                  />
                </div>

                {/* BOOKING/BL */}
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">
                    {formData.tipoOperacion === "importacion"
                      ? "Bill of Lading"
                      : "Booking"}
                  </label>
                  <input
                    type="text"
                    name="codigoViaje"
                    value={formData.codigoViaje || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, codigoViaje: e.target.value })
                    }
                    placeholder={
                      formData.tipoOperacion === "importacion"
                        ? "Ingrese el Bill of Lading"
                        : "Ingrese el código de Booking"
                    }
                    className={`w-full px-2 py-1.5 text-sm border rounded focus:ring-1 focus:ring-emerald-500 focus:border-emerald-500 ${isEditMode ? "border-green-300" : "border-gray-300"
                      }`}
                  />
                </div>

                {/* CONTENEDOR */}
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">
                    Contenedor
                  </label>
                  <input
                    type="text"
                    name="contenedor"
                    value={formData.contenedor || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, contenedor: e.target.value })
                    }
                    placeholder="Ej: TCLU1234567"
                    className={`w-full px-2 py-1.5 text-sm border rounded focus:ring-1 focus:ring-emerald-500 focus:border-emerald-500 ${isEditMode ? "border-green-300" : "border-gray-300"
                      }`}
                  />
                </div>
                {/* Posicionamiento en Destino */}
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">
                    Posicionamiento en Destino
                  </label>
                  <input
                    type="datetime-local" //
                    name="fechaFinProgramada"
                    value={formData.fechaFinProgramada || ""}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        fechaFinProgramada: e.target.value,
                      })
                    }
                    className={`w-full px-2 py-1.5 text-sm border rounded focus:ring-1 focus:ring-emerald-500 focus:border-emerald-500 ${isEditMode ? "border-green-300" : "border-gray-300"
                      }`}
                  />
                </div>
              </div>

              {/* Empresas y Recursos */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                {/* Panel de Empresas */}
                <div className="bg-green-50 p-3 rounded-lg border border-green-200">
                  <h3 className="font-semibold text-green-900 mb-2 flex items-center text-sm">
                    <Building2 className="mr-2 h-4 w-4" />
                    Empresas
                  </h3>

                  <div className="space-y-2">
                    {userRole === "operador_logistico" ? (
                      <>
                        {/* Generador de Carga */}
                        <div>
                          <label className="block text-xs font-medium text-gray-700 mb-1">
                            Generador de Carga
                          </label>
                          <select
                            value={formData.operadorLogisticoId}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                operadorLogisticoId: e.target.value,
                              })
                            }
                            className="select-fixed-height w-full px-2 py-1.5 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-emerald-500 focus:border-emerald-500 bg-gray-100"
                            disabled={true}
                          >
                            <option value="">Seleccionar...</option>
                            {operadoresLogisticos.map((op) => (
                              <option key={op.id} value={op.id}>
                                {op.nombre}
                              </option>
                            ))}
                          </select>
                        </div>

                        {/* TRANSPORTISTA */}
                        <div>
                          <label className="block text-xs font-medium text-gray-700 mb-1">
                            Transportista
                          </label>
                          <Select
                            options={opcionesTransportistas}
                            value={
                              opcionesTransportistas.find(
                                (opt) => opt.value === formData.transportistaId,
                              ) || null
                            }
                            onChange={(opcion) =>
                              setFormData({
                                ...formData,
                                transportistaId: opcion?.value,
                              })
                            }
                            placeholder="Seleccionar transportista..."
                            className="text-sm"
                            styles={{
                              control: (base) => ({
                                ...base,
                                borderColor: "#d1d5db",
                                minHeight: "36px",
                                fontSize: "0.875rem",
                                backgroundColor: "#ffffff",
                              }),
                            }}
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        {/* TRANSPORTISTA */}
                        <div>
                          <label className="block text-xs font-medium text-gray-700 mb-1">
                            Transportista
                          </label>
                          <select
                            value={formData.transportistaId}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                transportistaId: e.target.value,
                              })
                            }
                            className="select-fixed-height w-full px-2 py-1.5 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-emerald-500 focus:border-emerald-500 bg-gray-100"
                            disabled={true}
                          >
                            <option value="">Seleccionar...</option>
                            {transportistas.map((t) => (
                              <option key={t.id} value={t.id}>
                                {t.nombre}
                              </option>
                            ))}
                          </select>
                        </div>

                        {/* Generador de Carga */}
                        <div>
                          <label className="block text-xs font-medium text-gray-700 mb-1">
                            Generador de Carga
                          </label>
                          <Select
                            options={opcionesOperadores}
                            value={
                              opcionesOperadores.find(
                                (opt) =>
                                  opt.value === formData.operadorLogisticoId,
                              ) || null
                            }
                            onChange={(opcion) =>
                              setFormData({
                                ...formData,
                                operadorLogisticoId: opcion?.value,
                              })
                            }
                            placeholder="Seleccionar operador..."
                            className="text-sm"
                            styles={{
                              control: (base) => ({
                                ...base,
                                borderColor: "#d1d5db",
                                minHeight: "36px",
                                fontSize: "0.875rem",
                                backgroundColor: "#ffffff",
                              }),
                            }}
                          />
                        </div>
                      </>
                    )}

                    {/* CLIENTE FINAL - SIEMPRE HABILITADO */}
                    <div>
                      <label className="block text-xs font-medium text-gray-700 mb-1">
                        Cliente Final
                      </label>
                      <Select
                        options={opcionesClientes}
                        value={
                          opcionesClientes.find(
                            (opt) => opt.value === formData.clienteId,
                          ) || null
                        }
                        onChange={(opcion) =>
                          setFormData((prev) => ({
                            ...prev,
                            clienteId: opcion?.value,
                          }))
                        }
                        placeholder="Seleccionar cliente..."
                        isDisabled={clientes.length === 0}
                        className="text-sm"
                        styles={{
                          control: (base) => ({
                            ...base,
                            borderColor: "#d1d5db",
                            minHeight: "36px",
                            fontSize: "0.875rem",
                          }),
                        }}
                      />
                    </div>
                  </div>
                </div>

                {/* Panel de Recursos */}
                <div className="bg-green-50 p-3 rounded-lg border border-green-200">
                  <h3 className="font-semibold text-green-900 mb-2 flex items-center text-sm">
                    <Truck className="mr-2 h-4 w-4" />
                    Recursos Asignados
                  </h3>

                  <div className="space-y-2">
                    {/* ── 1. CONDUCTOR ── */}
                    <div>
                      <label className="block text-xs font-medium text-gray-700 mb-1">
                        Conductor
                        <span className="ml-1 text-[10px] font-normal text-gray-400">
                          — elige primero para autocompletar placas
                        </span>
                      </label>
                      <Select
                        options={opcionesChoferes}
                        value={
                          opcionesChoferes.find(
                            (o) => o.value === formData.choferId,
                          ) || null
                        }
                        onChange={(opcion) => {
                          setFormData((prev) => ({
                            ...prev,
                            choferId: opcion?.value ?? "",
                            camionId: "",
                            chasisId: "",
                          }));
                          setHintVehiculos("");
                          if (opcion?.value)
                            fetchVehiculosConductor(opcion.value);
                        }}
                        placeholder="Seleccionar conductor..."
                        isDisabled={choferes.length === 0}
                        className="text-sm"
                        styles={{
                          control: (base) => ({
                            ...base,
                            borderColor: formData.choferId
                              ? "#10b981"
                              : "#d1d5db",
                            minHeight: "36px",
                            fontSize: "0.875rem",
                          }),
                        }}
                      />
                      {choferes.length === 0 && (
                        <p className="text-xs text-amber-600 mt-1">
                          Selecciona primero el transportista
                        </p>
                      )}
                      {!loadingVehiculosConductor &&
                        formData.choferId &&
                        hintVehiculos === "asignacion_fija" && (
                          <p className="text-[10px] text-emerald-600 mt-1">
                            ✓ Remolcador y semirremolque asignados a este
                            conductor
                          </p>
                        )}
                      {!loadingVehiculosConductor &&
                        formData.choferId &&
                        hintVehiculos === "ultimo_viaje" && (
                          <p className="text-[10px] text-blue-600 mt-1">
                            ✓ Autocompletado desde el último viaje del conductor
                          </p>
                        )}
                      {!loadingVehiculosConductor &&
                        formData.choferId &&
                        (hintVehiculos === "sin_asignacion" ||
                          hintVehiculos === "error") && (
                          <p className="text-[10px] text-amber-600 mt-1">
                            ⚠ Sin asignación fija — selecciona remolcador y
                            semirremolque manualmente
                          </p>
                        )}
                    </div>

                    {/* ── 2. REMOLCADOR ── */}
                    <div>
                      <label className="block text-xs font-medium text-gray-700 mb-1 flex items-center gap-1.5">
                        Remolcador
                        {loadingVehiculosConductor && (
                          <span className="w-3 h-3 border-2 border-emerald-500 border-t-transparent rounded-full animate-spin" />
                        )}
                      </label>
                      <Select
                        options={opcionesCamiones}
                        value={
                          opcionesCamiones.find(
                            (o) => o.value === formData.camionId,
                          ) || null
                        }
                        onChange={(opcion) =>
                          setFormData((prev) => ({
                            ...prev,
                            camionId: opcion?.value ?? "",
                          }))
                        }
                        placeholder={
                          !formData.choferId
                            ? "Primero selecciona un conductor"
                            : loadingVehiculosConductor
                              ? "Buscando..."
                              : "Seleccionar remolcador..."
                        }
                        isDisabled={
                          camionesSeguros.length === 0 ||
                          loadingVehiculosConductor
                        }
                        className="text-sm"
                        styles={{
                          control: (base) => ({
                            ...base,
                            borderColor:
                              formData.camionId && !loadingVehiculosConductor
                                ? "#10b981"
                                : "#d1d5db",
                            minHeight: "36px",
                            fontSize: "0.875rem",
                            backgroundColor: loadingVehiculosConductor
                              ? "#f9fafb"
                              : "#fff",
                          }),
                        }}
                      />
                    </div>

                    {/* ── 3. SEMIRREMOLQUE ── */}
                    <div>
                      <label className="block text-xs font-medium text-gray-700 mb-1 flex items-center gap-1.5">
                        Semirremolque
                        {loadingVehiculosConductor && (
                          <span className="w-3 h-3 border-2 border-emerald-500 border-t-transparent rounded-full animate-spin" />
                        )}
                      </label>
                      <Select
                        options={opcionesChasis}
                        value={
                          opcionesChasis.find(
                            (o) => o.value === formData.chasisId,
                          ) || null
                        }
                        onChange={(opcion) =>
                          setFormData((prev) => ({
                            ...prev,
                            chasisId: opcion?.value ?? "",
                          }))
                        }
                        placeholder={
                          !formData.choferId
                            ? "Primero selecciona un conductor"
                            : loadingVehiculosConductor
                              ? "Buscando..."
                              : "Seleccionar semirremolque..."
                        }
                        isDisabled={
                          chasis.length === 0 || loadingVehiculosConductor
                        }
                        className="text-sm"
                        styles={{
                          control: (base) => ({
                            ...base,
                            borderColor:
                              formData.chasisId && !loadingVehiculosConductor
                                ? "#10b981"
                                : "#d1d5db",
                            minHeight: "36px",
                            fontSize: "0.875rem",
                            backgroundColor: loadingVehiculosConductor
                              ? "#f9fafb"
                              : "#fff",
                          }),
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Gestión de Tramos */}
              <div
                className={`p-4 rounded-lg border ${isEditMode
                  ? "bg-gray-50 border-gray-300"
                  : "bg-gradient-to-br from-purple-50 to-indigo-50 border-purple-200"
                  }`}
              >
                <h3
                  className={`font-semibold mb-3 flex items-center text-sm ${isEditMode ? "text-gray-700" : "text-purple-900"
                    }`}
                >
                  <Route className="mr-2 h-4 w-4" />
                  Tramos del Viaje
                </h3>

                <div className="space-y-3">
                  {(formData.tramos || []).map((tramo, index) => {
                    const opcionesOrigenTramo =
                      formData.tipoOperacion === "exportacion"
                        ? getEstablecimientosFiltrados("", "origen")
                          .filter((est) => est.tipo === "ALMACEN")
                          .sort((a, b) =>
                            (a.nombre || "").localeCompare(b.nombre || ""),
                          )
                          .map((est) => ({
                            value: est.id,
                            label: `${est.nombre} - ${est.direccion}`,
                          }))
                        : getEstablecimientosFiltrados("", "origen")
                          .sort((a, b) =>
                            (a.nombre || "").localeCompare(b.nombre || ""),
                          )
                          .map((est) => ({
                            value: est.id,
                            label: `${est.nombre} (${est.tipo}) - ${est.direccion}`,
                          }));

                    const opcionesDestinoTramo = getEstablecimientosFiltrados(
                      tramo.tipoActividad,
                      "destino",
                    )
                      .sort((a, b) =>
                        (a.nombre || "").localeCompare(b.nombre || ""),
                      )
                      .map((est) => ({
                        value: est.id,
                        label: `${est.nombre} (${est.tipo}) - ${est.direccion}`,
                      }));

                    return (
                      <div
                        key={tramo.id || index}
                        className={`p-3 rounded-lg border ${isEditMode
                          ? "border-gray-200 bg-gray-100"
                          : "border-purple-100 bg-white"
                          }`}
                      >
                        <div className="flex items-center justify-between mb-3">
                          <span
                            className={`text-sm font-medium ${isEditMode ? "text-gray-700" : "text-purple-900"
                              }`}
                          >
                            Tramo {index + 1}
                            {isEditMode && tramo.estado && (
                              <span
                                className={`ml-2 px-2 py-1 rounded-full text-xs ${tramo.estado === "pendiente"
                                  ? "bg-blue-100 text-blue-800"
                                  : "bg-gray-100 text-gray-600"
                                  }`}
                              >
                                {tramo.estado.toUpperCase()}
                              </span>
                            )}
                          </span>
                          {!isEditMode && index > 0 && (
                            <button
                              type="button"
                              onClick={() => removeTramo(index)}
                              className="text-red-500 hover:text-red-700"
                            >
                              <X className="h-4 w-4" />
                            </button>
                          )}
                        </div>

                        {isEditMode ? (
                          /* MODO LECTURA PARA TRAMOS EN EDICIÓN */
                          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 text-sm">
                            <div>
                              <span className="text-gray-600 font-medium">
                                Origen:
                              </span>
                              <p className="text-gray-800">
                                {tramo.origen.nombre || "No definido"} (
                                {tramo.origen.tipo})
                              </p>
                            </div>
                            <div>
                              <span className="text-gray-600 font-medium">
                                Actividad:
                              </span>
                              <p className="text-gray-800">
                                {tramo.tipoActividad || "No definida"}
                              </p>
                            </div>
                            <div>
                              <span className="text-gray-600 font-medium">
                                Destino:
                              </span>
                              <p className="text-gray-800">
                                {tramo.destino.nombre || "No definido"} (
                                {tramo.destino.tipo})
                              </p>
                            </div>
                          </div>
                        ) : (
                          /* FORMULARIO COMPLETO DE TRAMO EN MODO CREACIÓN */
                          <>
                            {/* Fila 1: Establecimientos y Tipo de Actividad */}
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-3">
                              {/* Origen del tramo */}
                              <div className="space-y-2">
                                <label className="block text-xs font-medium text-gray-700">
                                  Establecimiento Origen
                                </label>
                                <Select
                                  options={opcionesOrigenTramo}
                                  value={
                                    opcionesOrigenTramo.find(
                                      (opt) =>
                                        opt.value ===
                                        tramo.origen.establecimientoId,
                                    ) || null
                                  }
                                  onChange={(opcion) => {
                                    const selectedEst =
                                      getEstablecimientosFiltrados(
                                        "",
                                        "origen",
                                      ).find((est) => est.id === opcion?.value);
                                    if (selectedEst) {
                                      updateTramo(
                                        index,
                                        "origen",
                                        "establecimientoId",
                                        selectedEst.id,
                                      );
                                      updateTramo(
                                        index,
                                        "origen",
                                        "nombre",
                                        selectedEst.nombre,
                                      );
                                      updateTramo(
                                        index,
                                        "origen",
                                        "tipo",
                                        selectedEst.tipo,
                                      );
                                    }
                                  }}
                                  placeholder="Seleccionar almacén..."
                                  isDisabled={!formData.navieraId}
                                  className="text-xs"
                                  styles={{
                                    control: (base) => ({
                                      ...base,
                                      borderColor: "#d1d5db",
                                      minHeight: "32px",
                                      fontSize: "0.75rem",
                                    }),
                                  }}
                                />
                                {!formData.navieraId && (
                                  <p className="text-xs text-amber-600">
                                    Selecciona primero la naviera
                                  </p>
                                )}
                              </div>

                              {/* Tipo de Actividad */}
                              <div className="space-y-2">
                                <label className="block text-xs font-medium text-gray-700">
                                  Tipo de Actividad
                                </label>
                                <select
                                  value={tramo.tipoActividad || ""}
                                  onChange={(e) => {
                                    updateTramo(
                                      index,
                                      "tipoActividad",
                                      "",
                                      e.target.value,
                                    );
                                    updateTramo(
                                      index,
                                      "destino",
                                      "establecimientoId",
                                      "",
                                    );
                                    updateTramo(index, "destino", "nombre", "");
                                    updateTramo(index, "destino", "tipo", "");
                                  }}
                                  className="select-fixed-height w-full px-2 py-1.5 text-xs border border-gray-300 rounded focus:ring-1 focus:ring-emerald-500"
                                >
                                  <option value="">
                                    Seleccionar actividad...
                                  </option>

                                  {/* EXPORTACIÓN - Primer tramo */}
                                  {formData.tipoOperacion === "exportacion" &&
                                    index === 0 ? (
                                    <>
                                      <option value="recojo">
                                        Retiro de vacío
                                      </option>
                                      <option value="recojo_anticipado">
                                        Retiro anticipado de vacío
                                      </option>
                                    </>
                                  ) : /* ✅ NUEVO: IMPORTACIÓN - Primer tramo */
                                  formData.tipoOperacion === "importacion" &&
                                    index === 0 ? (
                                    <>
                                      <option value="retiro">
                                        Retiro de lleno
                                      </option>
                                      <option value="entrega">
                                        Entrega a almacén
                                      </option>
                                      <option value="traslado">
                                        Traslado entre plantas
                                      </option>
                                    </>
                                  ) : (
                                    /* Otros tramos - todas las operaciones */
                                    <>
                                      <option value="recojo">Recojo</option>
                                      <option value="entrega">Entrega</option>
                                      <option value="traslado">Traslado</option>
                                      <option value="carga">Carga</option>
                                      <option value="descarga">Descarga</option>
                                      <option value="inspeccion">
                                        Inspección
                                      </option>
                                    </>
                                  )}
                                </select>
                              </div>

                              {/* Destino del tramo */}
                              <div className="space-y-2">
                                <label className="block text-xs font-medium text-gray-700">
                                  Establecimiento Destino
                                </label>
                                <Select
                                  options={opcionesDestinoTramo}
                                  value={
                                    opcionesDestinoTramo.find(
                                      (opt) =>
                                        opt.value ===
                                        tramo.destino.establecimientoId,
                                    ) || null
                                  }
                                  onChange={(opcion) => {
                                    const selectedEst =
                                      getEstablecimientosFiltrados(
                                        tramo.tipoActividad,
                                        "destino",
                                      ).find((est) => est.id === opcion?.value);
                                    if (selectedEst) {
                                      updateTramo(
                                        index,
                                        "destino",
                                        "establecimientoId",
                                        selectedEst.id,
                                      );
                                      updateTramo(
                                        index,
                                        "destino",
                                        "nombre",
                                        selectedEst.nombre,
                                      );
                                      updateTramo(
                                        index,
                                        "destino",
                                        "tipo",
                                        selectedEst.tipo,
                                      );
                                    }
                                  }}
                                  placeholder="Seleccionar establecimiento..."
                                  isDisabled={!tramo.tipoActividad}
                                  className="text-xs"
                                  styles={{
                                    control: (base) => ({
                                      ...base,
                                      borderColor: "#d1d5db",
                                      minHeight: "32px",
                                      fontSize: "0.75rem",
                                    }),
                                  }}
                                />
                                {!tramo.tipoActividad && (
                                  <p className="text-xs text-amber-600">
                                    Selecciona primero el tipo de actividad
                                  </p>
                                )}
                              </div>
                            </div>

                            {/* Fila 2: Fechas y Horas */}
                            <div className="grid grid-cols-1 md:grid-cols-4 gap-3 mb-3">
                              <div className="space-y-2">
                                <label className="block text-xs font-medium text-gray-700">
                                  {tramo.tipoActividad === "recojo" ||
                                    tramo.tipoActividad === "recojo_anticipado"
                                    ? "Fecha Cita de retiro de vacío"
                                    : "Fecha Origen"}
                                </label>
                                <input
                                  type="date"
                                  value={tramo.fechaLlegadaOrigen || ""}
                                  onChange={(e) =>
                                    updateTramo(
                                      index,
                                      "fechaLlegadaOrigen",
                                      "",
                                      e.target.value,
                                    )
                                  }
                                  className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded focus:ring-1 focus:ring-emerald-500"
                                />
                              </div>

                              <div className="space-y-2">
                                <label className="block text-xs font-medium text-gray-700">
                                  {tramo.tipoActividad === "recojo" ||
                                    tramo.tipoActividad === "recojo_anticipado"
                                    ? "Hora Cita de retiro de vacío"
                                    : "Hora Origen"}
                                </label>
                                <input
                                  type="time"
                                  value={tramo.horaLlegadaOrigen || ""}
                                  onChange={(e) =>
                                    updateTramo(
                                      index,
                                      "horaLlegadaOrigen",
                                      "",
                                      e.target.value,
                                    )
                                  }
                                  className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded focus:ring-1 focus:ring-emerald-500"
                                />
                              </div>

                              {tramo.tipoActividad !== "recojo_anticipado" && (
                                <>
                                  <div className="space-y-2">
                                    <label className="block text-xs font-medium text-gray-700">
                                      {tramo.tipoActividad === "recojo"
                                        ? "Fecha posicionamiento Cliente"
                                        : tramo.tipoActividad ===
                                          "despacho_full"
                                          ? "Fecha Cita Puerto"
                                          : "Fecha Destino"}
                                    </label>
                                    <input
                                      type="date"
                                      value={tramo.fechaSalidaDestino || ""}
                                      onChange={(e) =>
                                        updateTramo(
                                          index,
                                          "fechaSalidaDestino",
                                          "",
                                          e.target.value,
                                        )
                                      }
                                      className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded focus:ring-1 focus:ring-emerald-500"
                                    />
                                  </div>

                                  <div className="space-y-2">
                                    <label className="block text-xs font-medium text-gray-700">
                                      {tramo.tipoActividad === "recojo"
                                        ? "Hora posicionamiento Cliente"
                                        : tramo.tipoActividad ===
                                          "despacho_full"
                                          ? "Hora Cita Puerto"
                                          : "Hora Destino"}
                                    </label>
                                    <input
                                      type="time"
                                      value={tramo.horaSalidaDestino || ""}
                                      onChange={(e) =>
                                        updateTramo(
                                          index,
                                          "horaSalidaDestino",
                                          "",
                                          e.target.value,
                                        )
                                      }
                                      className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded focus:ring-1 focus:ring-emerald-500"
                                    />
                                  </div>
                                </>
                              )}
                            </div>

                            {/* Fila 3: Observaciones */}
                            <div className="mb-3">
                              <label className="block text-xs font-medium text-gray-700 mb-1">
                                Observaciones del Tramo
                              </label>
                              <textarea
                                value={tramo.observaciones || ""}
                                onChange={(e) =>
                                  updateTramo(
                                    index,
                                    "observaciones",
                                    "",
                                    e.target.value,
                                  )
                                }
                                placeholder="Observaciones adicionales para este tramo..."
                                className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded focus:ring-1 focus:ring-emerald-500"
                                rows="2"
                              />
                            </div>

                            <div className="flex items-center justify-between">
                              {tramo.estado === "completado" &&
                                index === formData.tramos.length - 1 && (
                                  <button
                                    type="button"
                                    onClick={addTramo}
                                    className="px-3 py-1 text-xs bg-purple-100 text-purple-700 hover:bg-purple-200 rounded"
                                  >
                                    + Agregar siguiente tramo
                                  </button>
                                )}
                            </div>
                          </>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  };
  // Modal de visualización
  const renderViewModal = () => {
    if (!showModal || modalType !== "view" || !selectedViaje) return null;

    return (
      <div className="fixed inset-0 z-[100] flex items-center justify-center">
        <div
          className="absolute inset-0 bg-black/50 backdrop-blur-sm"
          onClick={closeModal}
        />

        <div className="relative bg-white/95 backdrop-blur-md rounded-xl shadow-2xl border border-white/20 max-w-5xl max-h-[90vh] mx-4 overflow-hidden">
          <div className="bg-gradient-to-r from-emerald-500 to-teal-600 px-6 py-4 text-white">
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <Package className="mr-3 h-6 w-6" />
                <div className="flex items-center divide-x divide-white/20">
                  {/* Correlativo */}
                  <div className="pr-3">
                    <span className="px-2 py-1 bg-white/20 text-white text-sm font-bold rounded-full">
                      {selectedViaje.correlativo || "N/A"}
                    </span>
                  </div>

                  {/* Código */}
                  <div className="px-3">
                    <h2 className="text-lg font-bold">
                      {selectedViaje.codigoViaje}
                    </h2>
                  </div>

                  {/* Tipo */}
                  <div className="pl-3">
                    <span className="px-3 py-1 bg-white/10 text-emerald-100 text-sm font-medium rounded-lg">
                      {selectedViaje.tipoOperacion.charAt(0).toUpperCase() +
                        selectedViaje.tipoOperacion.slice(1)}
                    </span>
                  </div>
                </div>
              </div>

              {/* Estado a la derecha */}
              <div className="flex items-center space-x-3">
                <span
                  className={`px-3 py-1 rounded-full text-xs font-medium flex items-center ${getStatusColor(
                    selectedViaje.estado,
                  )}`}
                >
                  {getStatusIcon(selectedViaje.estado)}
                  <span className="ml-1">
                    {selectedViaje.estado.replace("_", " ").toUpperCase()}
                  </span>
                </span>

                {/* Botones de reporte PDF - solo para viajes completados */}
                {selectedViaje.estado === "completado" && (
                  <>
                    <button
                      onClick={async () => {
                        if (pdfPreviewLoading || pdfDownloadLoading) return;
                        setPdfPreviewLoading(true);
                        try {
                          const token = localStorage.getItem("token");
                          const url = `${API_BASE_URL}/api/reportes/viaje/${selectedViaje.id}/pdf-preview?token=${encodeURIComponent(token)}`;
                          const res = await fetch(url, { headers: getApiHeaders() });
                          if (!res.ok) throw new Error("Error en la respuesta del servidor");
                          const blob = await res.blob();
                          setPdfPreviewUrl(URL.createObjectURL(blob));
                          setShowPdfPreview(true);
                        } catch (error) {
                          console.error("Error al generar vista previa:", error);
                          Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'No se pudo generar la vista previa del reporte.',
                            confirmButtonColor: '#3085d6'
                          });
                        } finally {
                          setPdfPreviewLoading(false);
                        }
                      }}
                      disabled={pdfPreviewLoading || pdfDownloadLoading}
                      className={`px-3 py-1 bg-blue-600 hover:bg-blue-700 text-white text-xs rounded-lg flex items-center transition-colors ${(pdfPreviewLoading || pdfDownloadLoading) ? 'opacity-50 cursor-not-allowed' : ''}`}
                      title="Vista previa del reporte"
                    >
                      {pdfPreviewLoading ? (
                        <svg className="animate-spin -ml-1 mr-1 h-3 w-3 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                      ) : (
                        <svg
                          className="h-3 w-3 mr-1"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                          />
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                          />
                        </svg>
                      )}
                      {pdfPreviewLoading ? "Generando..." : "Vista Previa"}
                    </button>
                    <button
                      onClick={async () => {
                        if (pdfPreviewLoading || pdfDownloadLoading) return;
                        setPdfDownloadLoading(true);
                        try {
                          const url = `${API_BASE_URL}/api/reportes/viaje/${selectedViaje.id}/pdf`;
                          const res = await fetch(url, { headers: getApiHeaders() });
                          if (!res.ok) throw new Error("Error en la respuesta del servidor");
                          const blob = await res.blob();
                          const a = document.createElement('a');
                          a.href = URL.createObjectURL(blob);
                          a.download = `reporte_${selectedViaje.codigo_viaje || selectedViaje.id}.pdf`;
                          a.click();
                        } catch (error) {
                          console.error("Error al descargar reporte:", error);
                          Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'No se pudo descargar el reporte.',
                            confirmButtonColor: '#3085d6'
                          });
                        } finally {
                          setPdfDownloadLoading(false);
                        }
                      }}
                      disabled={pdfPreviewLoading || pdfDownloadLoading}
                      className={`px-3 py-1 bg-green-600 hover:bg-green-700 text-white text-xs rounded-lg flex items-center transition-colors ${(pdfPreviewLoading || pdfDownloadLoading) ? 'opacity-50 cursor-not-allowed' : ''}`}
                      title="Descargar reporte PDF"
                    >
                      {pdfDownloadLoading ? (
                        <svg className="animate-spin -ml-1 mr-1 h-3 w-3 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                      ) : (
                        <svg
                          className="h-3 w-3 mr-1"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                          />
                        </svg>
                      )}
                      {pdfDownloadLoading ? "Descargando..." : "Descargar"}
                    </button>
                  </>
                )}

                <button
                  onClick={closeModal}
                  className="p-1 hover:bg-white/20 rounded"
                >
                  ✕
                </button>
              </div>
            </div>
          </div>

          <div className="p-4 overflow-y-auto max-h-[calc(90vh-80px)]">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
              {/* Información Principal */}
              <div className="lg:col-span-2 space-y-4">
                {/* Empresas  */}
                <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-4 rounded-lg border border-blue-200">
                  <h3 className="font-semibold text-blue-900 mb-2 flex items-center">
                    <Building2 className="mr-2 h-4 w-4" />
                    Empresas
                  </h3>
                  <div className="space-y-1">
                    {/* Transportista */}
                    <div className="grid grid-cols-12 gap-2 items-center">
                      <div className="col-span-3">
                        <span className="text-xs font-medium text-gray-600">
                          Transportista:
                        </span>
                      </div>
                      <div className="col-span-9">
                        <p className="text-xs font-medium text-blue-900">
                          {selectedViaje.empresaTransportista?.nombre ||
                            "No asignado"}
                        </p>
                      </div>
                    </div>

                    {/* Generador de Carga */}
                    <div className="grid grid-cols-12 gap-2 items-center">
                      <div className="col-span-3">
                        <span className="text-xs font-medium text-gray-600">
                          Generador de Carga:
                        </span>
                      </div>
                      <div className="col-span-9">
                        <p className="text-xs font-medium text-blue-900">
                          {selectedViaje.empresaOperador?.nombre ||
                            "No asignado"}
                        </p>
                      </div>
                    </div>

                    {/* Cliente */}
                    <div className="grid grid-cols-12 gap-2 items-center">
                      <div className="col-span-3">
                        <span className="text-xs font-medium text-gray-600">
                          Cliente:
                        </span>
                      </div>
                      <div className="col-span-9">
                        <p className="text-xs font-medium text-blue-900">
                          {selectedViaje.empresaCliente?.nombre ||
                            "No asignado"}
                        </p>
                      </div>
                    </div>

                    {/* Naviera */}
                    <div className="grid grid-cols-12 gap-2 items-center">
                      <div className="col-span-3">
                        <span className="text-xs font-medium text-gray-600">
                          Naviera:
                        </span>
                      </div>
                      <div className="col-span-9">
                        <p className="text-xs font-medium text-blue-900">
                          {selectedViaje.empresaNaviera?.nombre ||
                            "No asignada"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Recursos asignados */}
                <div className="bg-gradient-to-br from-green-50 to-emerald-50 p-4 rounded-lg border border-green-200">
                  <h3 className="font-semibold text-green-900 mb-2 flex items-center">
                    <Truck className="mr-2 h-4 w-4" />
                    Recursos Asignados
                  </h3>
                  <div className="space-y-1">
                    {/* Fila 1: Remolcador, Carreta y Contenedor */}
                    <div className="grid grid-cols-3 gap-4">
                      {/* Remolcador */}
                      <div className="flex items-center">
                        <Truck className="h-3 w-3 text-green-500 mr-2 flex-shrink-0" />
                        <div className="min-w-0 flex-1">
                          <span className="text-xs font-medium text-gray-600">
                            Remolcador:
                          </span>
                          {/* <p className="text-xs font-medium text-green-900 truncate">
                            {selectedViaje.vehiculo?.placa || "N/A"}
                            {selectedViaje.vehiculo?.marca &&
                              selectedViaje.vehiculo?.modelo &&
                              ` - ${selectedViaje.vehiculo.marca} ${selectedViaje.vehiculo.modelo}`}
                          </p> */}
                          <p className="text-xs font-medium text-green-900 truncate">
                            {selectedViaje.vehiculo?.placa || "N/A"}
                          </p>
                        </div>
                      </div>

                      {/* Carreta */}
                      <div className="flex items-center">
                        <Package className="h-3 w-3 text-green-500 mr-2 flex-shrink-0" />
                        <div className="min-w-0 flex-1">
                          <span className="text-xs font-medium text-gray-600">
                            Carreta:
                          </span>
                          <p className="text-xs font-medium text-green-900 truncate">
                            {selectedViaje.carreta?.placa || "N/A"}
                            {selectedViaje.carreta?.marca &&
                              selectedViaje.carreta?.modelo &&
                              ` - ${selectedViaje.carreta.marca} ${selectedViaje.carreta.modelo}`}
                          </p>
                        </div>
                      </div>

                      {/* Contenedor */}
                      <div className="flex items-center">
                        <Package className="h-3 w-3 text-green-500 mr-2 flex-shrink-0" />
                        <div className="min-w-0 flex-1">
                          <span className="text-xs font-medium text-gray-600">
                            Contenedor:
                          </span>
                          <p className="text-xs font-medium text-green-900 truncate">
                            {selectedViaje.contenedor || "No asignado"}
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Fila 2: Conductor (ocupa todo el ancho) */}
                    <div className="flex items-center pt-1">
                      <User className="h-3 w-3 text-green-500 mr-2" />
                      <span className="text-xs font-medium text-gray-600 mr-2">
                        Conductor:
                      </span>
                      <span className="text-xs font-medium text-green-900">
                        {selectedViaje.conductor
                          ? `${selectedViaje.conductor.nombre} ${selectedViaje.conductor.apellidos}`
                          : "No asignado"}
                        {selectedViaje.conductor?.licenciaCategoria &&
                          ` - Lic. ${selectedViaje.conductor.licenciaCategoria}`}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Tramos del Viaje */}
                <div className="bg-gradient-to-br from-purple-50 to-pink-50 p-3 rounded-lg border border-purple-200">
                  <div className="flex items-center justify-between mb-3">
                    <h3 className="font-semibold text-purple-900 flex items-center">
                      <Route className="mr-2 h-4 w-4" />
                      Tramos del Viaje ({selectedViaje.tramos?.length || 0})
                    </h3>
                    {selectedViaje.estado === "pendiente" && (
                      <button
                        onClick={() => {
                          setEditTramoId(null);

                          const esPrimerTramo =
                            !selectedViaje.tramos ||
                            selectedViaje.tramos.length === 0;
                          const ultimoTramo =
                            selectedViaje.tramos?.[
                            selectedViaje.tramos.length - 1
                            ];
                          const fechasDefecto = obtenerFechasDefecto();

                          const tractoId =
                            ultimoTramo?.tracto ||
                            selectedViaje.vehiculo?.id ||
                            "";
                          const chasisId =
                            ultimoTramo?.chasis ||
                            selectedViaje.carreta?.id ||
                            "";
                          const conductorId =
                            ultimoTramo?.conductor ||
                            selectedViaje.conductor?.id ||
                            "";

                          let nuevoTramoInicializado = {
                            origen: {
                              establecimientoId: esPrimerTramo
                                ? ""
                                : ultimoTramo?.establecimientoDestinoId ||
                                ultimoTramo?.establecimientoDestino?.id ||
                                "",
                              nombre: esPrimerTramo
                                ? ""
                                : ultimoTramo?.establecimientoDestino?.nombre ||
                                "",
                              tipo: esPrimerTramo
                                ? ""
                                : ultimoTramo?.establecimientoDestino?.tipo ||
                                "",
                            },
                            destino: {
                              establecimientoId: "",
                              nombre: "",
                              tipo: "",
                            },
                            estado: "pendiente",

                            tipoActividad: "",
                            fechaLlegadaOrigen: fechasDefecto.fechaActual,
                            horaLlegadaOrigen: fechasDefecto.horaActual,
                            fechaSalidaDestino: fechasDefecto.fechaDosHoras,
                            horaSalidaDestino: fechasDefecto.horaDosHoras,
                            observaciones: "",
                            tractoId,
                            chasisId,
                            conductorId,
                          };

                          if (!esPrimerTramo) {
                            const primerTramo = selectedViaje.tramos[0];
                            const numeroTramo = selectedViaje.tramos.length + 1;

                            if (numeroTramo === 2) {
                              if (primerTramo.tipoActividad === "recojo") {
                                nuevoTramoInicializado.tipoActividad =
                                  "despacho_full";

                                const puertos = establecimientos.filter(
                                  (est) => est.tipo === "PUERTO" && est.activo,
                                );
                                if (puertos.length > 0) {
                                  nuevoTramoInicializado.destino = {
                                    establecimientoId: puertos[0].id,
                                    nombre: puertos[0].nombre,
                                    tipo: puertos[0].tipo,
                                  };
                                }
                              } else if (
                                primerTramo.tipoActividad ===
                                "recojo_anticipado"
                              ) {
                                nuevoTramoInicializado.tipoActividad =
                                  "entrega_planta";

                                const plantas = establecimientos.filter(
                                  (est) =>
                                    est.tipo === "PLANTA" &&
                                    est.activo &&
                                    !est.publico,
                                );
                                if (plantas.length > 0) {
                                  nuevoTramoInicializado.destino = {
                                    establecimientoId: plantas[0].id,
                                    nombre: plantas[0].nombre,
                                    tipo: plantas[0].tipo,
                                  };
                                }
                              }
                            } else if (
                              numeroTramo === 3 &&
                              primerTramo.tipoActividad === "recojo_anticipado"
                            ) {
                              nuevoTramoInicializado.tipoActividad =
                                "despacho_full";

                              const puertos = establecimientos.filter(
                                (est) => est.tipo === "PUERTO" && est.activo,
                              );
                              if (puertos.length > 0) {
                                nuevoTramoInicializado.destino = {
                                  establecimientoId: puertos[0].id,
                                  nombre: puertos[0].nombre,
                                  tipo: puertos[0].tipo,
                                };
                              }
                            }
                          }

                          setNuevoTramo(nuevoTramoInicializado);
                          setShowTramosModal(true);
                        }}
                        className="px-3 py-1 text-xs bg-purple-100 text-purple-700 hover:bg-purple-200 rounded-full transition-colors"
                      >
                        + Agregar Tramo
                      </button>
                    )}
                  </div>

                  {selectedViaje.tramos && selectedViaje.tramos.length > 0 ? (
                    <div className="space-y-2">
                      {selectedViaje.tramos.map((tramo, index) => (
                        <div
                          key={tramo.id || index}
                          className="bg-white p-2 rounded-lg border border-purple-100"
                        >
                          <div className="flex items-center justify-between mb-2">
                            <span className="text-sm font-medium text-purple-900">
                              Tramo {tramo.orden || index + 1}
                            </span>
                            <span
                              className={`px-2 py-1 rounded-full text-xs ${getStatusColor(
                                tramo.estado,
                              )}`}
                            >
                              {tramo.estado.toUpperCase()}
                            </span>
                            {tramo.estado === "pendiente" && (
                              <div className="flex items-center space-x-2">
                                <button
                                  onClick={() => handleEditTramo(tramo)}
                                  className="p-1 text-purple-600 hover:text-purple-800 hover:bg-purple-100 rounded-full"
                                  title="Editar tramo"
                                >
                                  <Edit className="h-4 w-4" />
                                </button>
                                <button
                                  onClick={() => handleDeleteTramo(tramo)}
                                  className="p-1 text-red-600 hover:text-red-800 hover:bg-red-100 rounded-full"
                                  title="Eliminar tramo"
                                >
                                  <Trash2 className="h-4 w-4" />
                                </button>
                              </div>
                            )}
                          </div>

                          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
                            <div>
                              <span className="text-gray-600">Origen:</span>
                              <p className="font-medium text-purple-900">
                                {tramo.establecimientoOrigen?.nombre ||
                                  "No definido"}
                              </p>
                              <p className="text-xs text-gray-500">
                                {tramo.establecimientoOrigen?.direccion}
                              </p>
                            </div>
                            <div>
                              <span className="text-gray-600">Destino:</span>
                              <p className="font-medium text-purple-900">
                                {tramo.establecimientoDestino?.nombre ||
                                  "No definido"}
                              </p>
                              <p className="text-xs text-gray-500">
                                {tramo.establecimientoDestino?.direccion}
                              </p>
                            </div>
                          </div>

                          <div className="mt-2 text-xs text-gray-600">
                            <span className="font-medium">Actividad:</span>{" "}
                            {tramo.tipoActividad}
                            {tramo.descripcion && (
                              <>
                                <br />
                                <span className="font-medium">
                                  Descripción:
                                </span>{" "}
                                {tramo.descripcion}
                              </>
                            )}
                          </div>

                          {tramo.horaLlegadaProgramada && (
                            <div className="mt-2 text-xs text-gray-600">
                              <span className="font-medium">Programado:</span>{" "}
                              {new Date(
                                tramo.horaLlegadaProgramada,
                              ).toLocaleString()}{" "}
                              -{" "}
                              {tramo.horaSalidaProgramada
                                ? new Date(
                                  tramo.horaSalidaProgramada,
                                ).toLocaleString()
                                : "Sin hora de salida"}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="text-center py-4 text-gray-500 text-sm">
                      No hay tramos definidos para este viaje
                    </div>
                  )}
                </div>
              </div>

              {/* Panel lateral - Fechas y Estado */}
              <div className="space-y-4">
                {/* Cronología */}
                <div className="bg-gradient-to-br from-gray-50 to-slate-50 p-4 rounded-lg border border-gray-200">
                  <h3 className="font-semibold text-gray-900 mb-3 flex items-center">
                    <Calendar className="mr-2 h-4 w-4" />
                    Cronología
                  </h3>
                  <div className="space-y-3 text-sm">
                    {/* Inicio Programado */}
                    <div className="flex items-center">
                      <Calendar className="h-3 w-3 text-blue-500 mr-2" />
                      <div>
                        <span className="text-gray-600">
                          Inicio Programado:
                        </span>
                        <p className="font-medium">
                          {selectedViaje.fechaInicioProgramada
                            ? new Date(
                              selectedViaje.fechaInicioProgramada,
                            ).toLocaleString("es-PE", {
                              year: "numeric",
                              month: "2-digit",
                              day: "2-digit",
                              hour: "2-digit",
                              minute: "2-digit",
                            })
                            : "No programado"}
                        </p>
                      </div>
                    </div>

                    {/* Fin Programado */}
                    <div className="flex items-center">
                      <Clock className="h-3 w-3 text-orange-500 mr-2" />
                      <div>
                        <span className="text-gray-600">Fin Programado:</span>
                        <p className="font-medium">
                          {selectedViaje.fechaFinProgramada
                            ? new Date(
                              selectedViaje.fechaFinProgramada,
                            ).toLocaleString("es-PE", {
                              year: "numeric",
                              month: "2-digit",
                              day: "2-digit",
                              hour: "2-digit",
                              minute: "2-digit",
                            })
                            : "No programado"}
                        </p>
                      </div>
                    </div>

                    {/* Inicio Real */}
                    {selectedViaje.tramos?.[0]?.horaLlegadaReal && (
                      <div className="flex items-center">
                        <CheckCircle className="h-3 w-3 text-green-500 mr-2" />
                        <div>
                          <span className="text-gray-600">Inicio Real:</span>
                          <p className="font-medium">
                            {new Date(
                              selectedViaje.tramos[0].horaLlegadaReal,
                            ).toLocaleString("es-PE", {
                              year: "numeric",
                              month: "2-digit",
                              day: "2-digit",
                              hour: "2-digit",
                              minute: "2-digit",
                            })}
                          </p>
                        </div>
                      </div>
                    )}

                    {/* Finalizado */}

                    {selectedViaje.fechaFinReal && (
                      <div className="flex items-center">
                        <CheckCircle className="h-3 w-3 text-green-500 mr-2" />
                        <div>
                          <span className="text-gray-600">Finalizado:</span>
                          <p className="font-medium">
                            {new Date(
                              selectedViaje.fechaFinReal,
                            ).toLocaleString("es-PE", {
                              year: "numeric",
                              month: "2-digit",
                              day: "2-digit",
                              hour: "2-digit",
                              minute: "2-digit",
                            })}
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Progreso del viaje */}
                <div className="bg-gradient-to-br from-indigo-50 to-blue-50 p-4 rounded-lg border border-indigo-200">
                  <h3 className="font-semibold text-indigo-900 mb-3 flex items-center">
                    <Route className="mr-2 h-4 w-4" />
                    Progreso del Viaje
                  </h3>
                  <div className="space-y-3">
                    <div className="flex items-center justify-between text-sm">
                      <span className="text-gray-600">Estado Actual:</span>
                      <span
                        className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(
                          selectedViaje.estado,
                        )}`}
                      >
                        {selectedViaje.estado.replace("_", " ").toUpperCase()}
                      </span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2">
                      <div
                        className="bg-gradient-to-r from-emerald-500 to-teal-600 h-2 rounded-full transition-all duration-300"
                        style={{
                          width: `${getProgressPercentage(
                            selectedViaje.estado,
                          )}%`,
                        }}
                      />
                    </div>
                    <div className="grid grid-cols-4 gap-2 text-xs">
                      <div className="text-center">
                        <div
                          className={`w-3 h-3 rounded-full mx-auto mb-1 ${selectedViaje.estado === "pendiente"
                            ? "bg-blue-500"
                            : "bg-gray-300"
                            }`}
                        />
                        <span className="text-gray-600">Pendiente</span>
                      </div>
                      <div className="text-center">
                        <div
                          className={`w-3 h-3 rounded-full mx-auto mb-1 ${["en_curso", "completado"].includes(
                            selectedViaje.estado,
                          )
                            ? "bg-orange-500"
                            : "bg-gray-300"
                            }`}
                        />
                        <span className="text-gray-600">En Curso</span>
                      </div>
                      <div className="text-center">
                        <div
                          className={`w-3 h-3 rounded-full mx-auto mb-1 ${selectedViaje.estado === "completado"
                            ? "bg-green-500"
                            : "bg-gray-300"
                            }`}
                        />
                        <span className="text-gray-600">Completado</span>
                      </div>
                      <div className="text-center">
                        <div
                          className={`w-3 h-3 rounded-full mx-auto mb-1 ${selectedViaje.estado === "cancelado"
                            ? "bg-red-500"
                            : "bg-gray-300"
                            }`}
                        />
                        <span className="text-gray-600">Cancelado</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Observaciones */}
                {selectedViaje.observaciones && (
                  <div className="bg-gradient-to-br from-amber-50 to-yellow-50 p-4 rounded-lg border border-amber-200">
                    <h3 className="font-semibold text-amber-900 mb-2 flex items-center">
                      <AlertCircle className="mr-2 h-4 w-4" />
                      Observaciones
                    </h3>
                    <p className="text-sm text-amber-800">
                      {selectedViaje.observaciones}
                    </p>
                  </div>
                )}

                {/* Información del Documento */}
                {selectedViaje.documentoEmbarque && (
                  <div className="bg-gradient-to-br from-gray-50 to-slate-50 p-4 rounded-lg border border-gray-200">
                    <h3 className="font-semibold text-gray-900 mb-2 flex items-center">
                      <Package className="mr-2 h-4 w-4" />
                      Documento
                    </h3>
                    <p className="text-sm text-gray-700">
                      {selectedViaje.documentoEmbarque}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Modal para Agregar Tramo  */}
          {showTramosModal && (
            <div className="absolute inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-10">
              <div className="bg-white rounded-xl shadow-2xl border border-gray-200 m-4 max-w-4xl w-full max-h-[85vh] overflow-hidden">
                {/* Header mejorado */}
                <div className="bg-gradient-to-r from-purple-600 to-indigo-600 px-6 py-4">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <div className="bg-white/20 p-2 rounded-lg mr-3">
                        <Route className="h-5 w-5 text-white" />
                      </div>
                      <div>
                        <h3 className="text-lg font-bold text-white">
                          {editTramoId ? "Editar Tramo" : "Agregar Nuevo Tramo"}
                        </h3>
                        <p className="text-purple-100 text-sm">
                          {editTramoId
                            ? "Modifique los datos del tramo seleccionado"
                            : "Configure los detalles del siguiente tramo del viaje"}
                        </p>
                      </div>
                    </div>
                    <button
                      onClick={() => setShowTramosModal(false)}
                      className="text-white hover:bg-white/20 p-2 rounded-lg transition-colors"
                    >
                      <X className="h-5 w-5" />
                    </button>
                  </div>
                </div>

                {/* Content */}
                <div className="p-6 overflow-y-auto max-h-[calc(85vh-140px)]">
                  <div className="space-y-6">
                    {/* Fila principal: Origen, Actividad, Destino */}
                    <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                        {/* Establecimiento Origen */}
                        <div className="space-y-2">
                          <label className="block text-sm font-medium text-gray-700">
                            <MapPin className="h-4 w-4 inline mr-1 text-green-500" />
                            Establecimiento Origen
                          </label>
                          <div className="relative">
                            <select
                              value={nuevoTramo.origen.establecimientoId}
                              onChange={(e) => {
                                const selectedEst = establecimientos.find(
                                  (est) => est.id === e.target.value,
                                );
                                setNuevoTramo((prev) => ({
                                  ...prev,
                                  origen: {
                                    establecimientoId: e.target.value,
                                    nombre: selectedEst?.nombre || "",
                                    tipo: selectedEst?.tipo || "",
                                  },
                                }));
                              }}
                              disabled={
                                selectedViaje.tramos &&
                                selectedViaje.tramos.length > 0
                              }
                              className={`select-fixed-height w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 transition-all ${selectedViaje.tramos &&
                                selectedViaje.tramos.length > 0
                                ? "bg-gray-100 text-gray-500 cursor-not-allowed"
                                : "bg-white text-gray-900"
                                }`}
                            >
                              {selectedViaje.tramos &&
                                selectedViaje.tramos.length > 0 ? (
                                // Ya hay tramos - origen fijo del tramo anterior
                                <option
                                  value={nuevoTramo.origen.establecimientoId}
                                >
                                  {nuevoTramo.origen.nombre
                                    ? `${nuevoTramo.origen.nombre} (${nuevoTramo.origen.tipo})`
                                    : "Se asignará automáticamente desde el tramo anterior..."}
                                </option>
                              ) : (
                                <>
                                  <option value="">
                                    Seleccionar almacén origen...
                                  </option>
                                  {establecimientos
                                    .filter(
                                      (est) =>
                                        est.activo && est.tipo === "ALMACEN",
                                    ) // ✅ SOLO ALMACENES
                                    .sort((a, b) =>
                                      (a.nombre || "").localeCompare(
                                        b.nombre || "",
                                      ),
                                    )
                                    .map((est) => (
                                      <option key={est.id} value={est.id}>
                                        {est.nombre} - {est.direccion}
                                      </option>
                                    ))}
                                </>
                              )}
                            </select>
                          </div>
                        </div>

                        {/* Tipo de Actividad */}
                        <div className="space-y-2">
                          <label className="block text-sm font-medium text-gray-700">
                            <Truck className="h-4 w-4 inline mr-1 text-blue-500" />
                            Tipo de Actividad
                          </label>
                          <select
                            value={nuevoTramo.tipoActividad}
                            onChange={(e) =>
                              setNuevoTramo((prev) => ({
                                ...prev,
                                tipoActividad: e.target.value,
                              }))
                            }
                            className="select-fixed-height w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all"
                            disabled={
                              nuevoTramo.tipoActividad &&
                              selectedViaje.tramos?.length > 0
                            }
                          >
                            <option value="">Seleccionar actividad...</option>

                            {!selectedViaje.tramos ||
                              selectedViaje.tramos.length === 0 ? (
                              <>
                                <option value="recojo">Retiro de vacío</option>
                                <option value="recojo_anticipado">
                                  Retiro anticipado de vacío
                                </option>
                              </>
                            ) : (
                              <>
                                <option value="recojo">Recojo</option>
                                <option value="entrega">Entrega</option>
                                <option value="entrega_planta">
                                  Entrega en Planta
                                </option>
                                <option value="despacho_full">
                                  Ingreso Exportación a Puerto
                                </option>
                                <option value="carga">Carga</option>
                                <option value="descarga">Descarga</option>
                                <option value="inspeccion">Inspección</option>
                              </>
                            )}
                          </select>
                        </div>

                        {/* Establecimiento Destino */}
                        <div className="space-y-2">
                          <label className="block text-sm font-medium text-gray-700">
                            <MapPin className="h-4 w-4 inline mr-1 text-red-500" />
                            Establecimiento Destino
                          </label>
                          <select
                            value={nuevoTramo.destino.establecimientoId}
                            onChange={(e) => {
                              const selectedEst = establecimientos.find(
                                (est) => est.id === e.target.value,
                              );
                              setNuevoTramo((prev) => ({
                                ...prev,
                                destino: {
                                  establecimientoId: e.target.value,
                                  nombre: selectedEst?.nombre || "",
                                  tipo: selectedEst?.tipo || "",
                                },
                              }));
                            }}
                            className="select-fixed-height w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all"
                            disabled={!nuevoTramo.tipoActividad}
                          >
                            <option value="">
                              Seleccionar establecimiento...
                            </option>
                            {nuevoTramo.tipoActividad &&
                              establecimientos
                                .filter((est) => {
                                  if (!est.activo) return false;

                                  if (nuevoTramo.tipoActividad === "recojo") {
                                    return (
                                      est.tipo === "PLANTA" && !est.publico
                                    );
                                  } else if (
                                    nuevoTramo.tipoActividad ===
                                    "recojo_anticipado"
                                  ) {
                                    return (
                                      est.tipo === "COCHERA" && !est.publico
                                    );
                                  } else if (
                                    nuevoTramo.tipoActividad === "despacho_full"
                                  ) {
                                    return est.tipo === "PUERTO" && est.activo;
                                  } else if (
                                    nuevoTramo.tipoActividad ===
                                    "entrega_planta"
                                  ) {
                                    return (
                                      est.tipo === "PLANTA" && !est.publico
                                    );
                                  }

                                  return true;
                                })
                                .sort((a, b) =>
                                  (a.nombre || "").localeCompare(
                                    b.nombre || "",
                                  ),
                                )
                                .map((est) => (
                                  <option key={est.id} value={est.id}>
                                    {est.nombre} ({est.tipo}) - {est.direccion}
                                  </option>
                                ))}
                          </select>
                          {!nuevoTramo.tipoActividad && (
                            <p className="text-xs text-amber-600">
                              Selecciona primero el tipo de actividad
                            </p>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Programación de Fechas y Horas */}
                    <div className="bg-gradient-to-r from-amber-50 to-orange-50 p-4 rounded-lg border border-amber-200">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="space-y-3">
                          <h5 className="font-medium text-amber-800 flex items-center">
                            <Clock className="h-4 w-4 mr-2 text-green-500" />
                            {nuevoTramo.tipoActividad === "recojo" ||
                              nuevoTramo.tipoActividad === "recojo_anticipado"
                              ? "Fecha Cita de retiro de vacío"
                              : "Llegada al Origen"}
                          </h5>
                          <div className="grid grid-cols-2 gap-3">
                            <div>
                              <label className="block text-xs font-medium text-gray-700 mb-1">
                                Fecha
                              </label>
                              <input
                                type="date"
                                value={nuevoTramo.fechaLlegadaOrigen}
                                onChange={(e) =>
                                  setNuevoTramo((prev) => ({
                                    ...prev,
                                    fechaLlegadaOrigen: e.target.value,
                                  }))
                                }
                                className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-purple-500 text-sm"
                              />
                            </div>
                            <div>
                              <label className="block text-xs font-medium text-gray-700 mb-1">
                                Hora
                              </label>
                              <input
                                type="time"
                                value={nuevoTramo.horaLlegadaOrigen}
                                onChange={(e) =>
                                  setNuevoTramo((prev) => ({
                                    ...prev,
                                    horaLlegadaOrigen: e.target.value,
                                  }))
                                }
                                className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-purple-500 text-sm"
                              />
                            </div>
                          </div>
                        </div>
                        {nuevoTramo.tipoActividad !== "recojo_anticipado" && (
                          <div className="space-y-3">
                            <h5 className="font-medium text-amber-800 flex items-center">
                              <Clock className="h-4 w-4 mr-2 text-red-500" />
                              {nuevoTramo.tipoActividad === "recojo"
                                ? "Fecha posicionamiento Cliente"
                                : nuevoTramo.tipoActividad === "despacho_full"
                                  ? "Fecha Cita Puerto"
                                  : "Salida del Destino"}
                            </h5>
                            <div className="grid grid-cols-2 gap-3">
                              <div>
                                <label className="block text-xs font-medium text-gray-700 mb-1">
                                  Fecha
                                </label>
                                <input
                                  type="date"
                                  value={nuevoTramo.fechaSalidaDestino}
                                  onChange={(e) =>
                                    setNuevoTramo((prev) => ({
                                      ...prev,
                                      fechaSalidaDestino: e.target.value,
                                    }))
                                  }
                                  className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-purple-500 text-sm"
                                />
                              </div>
                              <div>
                                <label className="block text-xs font-medium text-gray-700 mb-1">
                                  Hora
                                </label>
                                <input
                                  type="time"
                                  value={nuevoTramo.horaSalidaDestino}
                                  onChange={(e) =>
                                    setNuevoTramo((prev) => ({
                                      ...prev,
                                      horaSalidaDestino: e.target.value,
                                    }))
                                  }
                                  className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-purple-500 text-sm"
                                />
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    {/* Vehiculo y Conductor */}
                    <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 mb-4 shadow-sm">
                      <div className="flex items-center mb-3">
                        <div className="flex items-center justify-center w-6 h-6 bg-blue-500 text-white rounded-full mr-2">
                          <i className="fas fa-truck" />
                        </div>
                        <h3 className="text-base font-semibold text-blue-800">
                          Datos de Unidad y Conductor
                        </h3>
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
                        {/* TRACTO */}
                        <div className="md:col-span-3">
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Tracto
                          </label>
                          <select
                            className="w-full border border-gray-300 rounded-lg py-2 px-3 text-sm focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition"
                            value={nuevoTramo.tractoId || ""}
                            onChange={(e) =>
                              setNuevoTramo({
                                ...nuevoTramo,
                                tractoId: e.target.value,
                              })
                            }
                            disabled={isPrimerTramo}
                          >
                            <option value="">Seleccione vehículo</option>
                            {vehiculosDisponibles.map((v) => (
                              <option key={v.id} value={v.id}>
                                {v.placa}
                                {v.marca ? ` — ${v.marca}` : ""}
                              </option>
                            ))}
                          </select>
                        </div>

                        {/* Semirremolque */}
                        <div className="md:col-span-3">
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Semirremolque
                          </label>
                          <select
                            className="w-full border border-gray-300 rounded-lg py-2 px-3 text-sm focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition"
                            value={nuevoTramo.chasisId || ""}
                            onChange={(e) =>
                              setNuevoTramo({
                                ...nuevoTramo,
                                chasisId: e.target.value,
                              })
                            }
                            disabled={isPrimerTramo}
                          >
                            <option value="">Seleccione carreta</option>
                            {carretasDisponibles.map((c) => (
                              <option key={c.id} value={c.id}>
                                {c.placa}
                                {c.marca ? ` — ${c.marca}` : ""}
                              </option>
                            ))}
                          </select>
                        </div>

                        {/* CONDUCTOR */}
                        <div className="md:col-span-6">
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Conductor
                          </label>
                          <select
                            className="w-full border border-gray-300 rounded-lg py-2 px-3 text-sm focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition"
                            value={nuevoTramo.conductorId || ""}
                            onChange={(e) =>
                              setNuevoTramo({
                                ...nuevoTramo,
                                conductorId: e.target.value,
                              })
                            }
                            disabled={isPrimerTramo}
                          >
                            <option value="">Seleccione conductor</option>
                            {conductoresDisponibles.map((m) => (
                              <option key={m.id} value={m.id}>
                                {m.nombre} {m.apellidos}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    {/* Observaciones */}
                    <div className="space-y-3">
                      <label className="block text-sm font-medium text-gray-700 flex items-center">
                        <Edit className="h-4 w-4 mr-2 text-gray-500" />
                        Observaciones del Tramo
                      </label>
                      <textarea
                        value={nuevoTramo.observaciones}
                        onChange={(e) =>
                          setNuevoTramo((prev) => ({
                            ...prev,
                            observaciones: e.target.value,
                          }))
                        }
                        placeholder="Agregue cualquier observación o instrucción especial para este tramo..."
                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all resize-none"
                        rows="3"
                      />
                    </div>
                  </div>
                </div>

                {/* Footer mejorado */}
                <div className="bg-gray-50 px-6 py-4 border-t border-gray-200">
                  <div className="flex justify-between items-center">
                    <div className="text-sm text-gray-600">
                      {editTramoId ? (
                        <span className="font-medium text-blue-700">
                          ✏️ Editando Tramo {nuevoTramo.orden}
                        </span>
                      ) : (
                        <span className="font-medium text-gray-700">
                          ➕ Tramo {(selectedViaje.tramos?.length || 0) + 1}
                        </span>
                      )}
                    </div>

                    <div className="flex space-x-3">
                      <button
                        onClick={() => setShowTramosModal(false)}
                        disabled={isSavingTramo}
                        className={`px-5 py-2 border border-gray-300 rounded-lg font-medium transition-all duration-200 shadow-sm ${isSavingTramo
                          ? "text-gray-400 bg-gray-100 cursor-not-allowed"
                          : "text-gray-700 bg-white hover:bg-gray-50"
                          }`}
                      >
                        Cancelar
                      </button>
                      <button
                        onClick={agregarTramo}
                        disabled={
                          !nuevoTramo.tipoActividad ||
                          !nuevoTramo.destino.establecimientoId ||
                          isSavingTramo
                        }
                        className={`px-5 py-2 text-white rounded-lg font-medium transition-all duration-200 shadow-sm flex items-center ${!nuevoTramo.tipoActividad ||
                          !nuevoTramo.destino.establecimientoId ||
                          isSavingTramo
                          ? "bg-gray-400 cursor-not-allowed"
                          : "bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700"
                          }`}
                      >
                        {isSavingTramo ? (
                          <>
                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                            Guardando...
                          </>
                        ) : (
                          <>
                            <Plus className="h-4 w-4 mr-2" />
                            {editTramoId ? "Actualizar Tramo" : "Agregar Tramo"}
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Footer */}
          <div className="bg-gray-50 px-6 py-3 border-t border-gray-200 flex justify-between">
            <button
              onClick={closeModal}
              className="px-4 py-2 text-gray-700 bg-gray-200 hover:bg-gray-300 rounded-lg font-medium transition-colors duration-200 text-sm"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    );
  };

  if (showCreateForm) {
    return renderCreateForm();
  }

  const renderEvidenciasModal = () => {
    if (!showEvidenciasModal) return null;

    const setInfo = evidenciasSets[activeEvidenciaSetKey];
    if (!setInfo) return null;

    const activeStatus = getSetStatus(activeEvidenciaSetKey);

    const getHeaderColorClass = () => {
      if (setInfo.condicional) return "from-amber-500 to-orange-600";
      if (userRole === "conductor") return "from-blue-500 to-indigo-600";
      return "from-green-500 to-emerald-600";
    };

    return (
      <div className="fixed inset-0 z-[100] flex items-center justify-center">
        <div
          className="absolute inset-0 bg-black/50 backdrop-blur-sm"
          onClick={() => setShowEvidenciasModal(false)}
        />

        <div className="relative bg-white rounded-xl shadow-2xl border border-gray-200 w-full max-w-6xl max-h-[90vh] mx-4 flex flex-col overflow-hidden">
          {/* Header */}
          <div className={`px-5 py-3 text-white bg-gradient-to-r ${getHeaderColorClass()}`}>
            <div className="flex items-center justify-between">
              <div className="flex items-center min-w-0">
                {userRole === "conductor" ? (
                  <Package className="mr-3 h-5 w-5 flex-shrink-0" />
                ) : (
                  <Eye className="mr-3 h-5 w-5 flex-shrink-0" />
                )}
                <div className="min-w-0">
                  <h2 className="text-lg font-bold truncate">
                    {userRole === "conductor"
                      ? "Gestionar Evidencias"
                      : "Ver Evidencias"}
                  </h2>
                  <p className="text-xs mt-0.5 opacity-90 truncate">
                    Viaje: {evidenciasViaje?.codigoViaje}
                  </p>
                </div>
              </div>
              <button
                onClick={() => setShowEvidenciasModal(false)}
                className="p-1 hover:bg-white/20 rounded ml-2 flex-shrink-0"
              >
                <X className="h-5 w-5" />
              </button>
            </div>
          </div>

          {/* Tabs */}
          <div className="bg-gray-50 border-b border-gray-200 overflow-x-auto flex-shrink-0">
            <div className="flex">
              {Object.entries(evidenciasSets).map(([key, set]) => {
                const st = getSetStatus(key);
                const isActive = key === activeEvidenciaSetKey;
                return (
                  <button
                    key={key}
                    onClick={() => handleEvidenciaTabChange(key)}
                    className={`flex-shrink-0 px-4 py-2.5 text-left transition-all border-b-2 min-w-0 ${
                      isActive
                        ? "bg-white border-blue-600 shadow-sm"
                        : "border-transparent hover:bg-gray-100 hover:border-gray-300"
                    }`}
                  >
                    <div className="flex items-center space-x-2">
                      <div
                        className={`flex items-center justify-center w-7 h-7 rounded-full text-xs font-bold flex-shrink-0 ${
                          isActive
                            ? "bg-blue-600 text-white"
                            : st.status === "complete"
                              ? "bg-emerald-500 text-white"
                              : st.status === "partial"
                                ? "bg-amber-400 text-white"
                                : "bg-gray-300 text-gray-600"
                        }`}
                      >
                        {st.status === "complete" ? (
                          <CheckCircle className="h-3.5 w-3.5" />
                        ) : (
                          key
                        )}
                      </div>
                      <div className="min-w-0">
                        <div className={`text-xs font-semibold leading-tight truncate ${isActive ? "text-gray-900" : "text-gray-600"}`}>
                          {set.nombre}
                        </div>
                        <div className={`text-[10px] leading-tight mt-0.5 ${isActive ? "text-gray-500" : "text-gray-400"}`}>
                          {st.completed}/{st.total}
                        </div>
                      </div>
                    </div>
                  </button>
                );
              })}
            </div>
          </div>

          {/* Content */}
          <div className="flex-1 overflow-y-auto p-5">
            {loadingEvidencias ? (
              <div className="flex flex-col items-center justify-center py-16">
                <div className="relative">
                  <div className="w-14 h-14 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>
                  <Package className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 h-5 w-5 text-blue-600" />
                </div>
                <p className="mt-4 text-gray-600 font-medium text-sm">
                  Cargando evidencias...
                </p>
              </div>
            ) : (
              <>
                {/* Progress bar */}
                <div className="mb-4">
                  <div className="flex items-center justify-between mb-1.5">
                    <h3 className="text-sm font-bold text-gray-800">
                      {setInfo.titulo}
                    </h3>
                    <span className="text-xs text-gray-500">
                      {activeStatus.completed}/{activeStatus.total} fotos
                    </span>
                  </div>
                  <div className="w-full h-1.5 bg-gray-200 rounded-full overflow-hidden">
                    <div
                      className={`h-full rounded-full transition-all duration-300 ${
                        activeStatus.completed === 0
                          ? "bg-gray-300"
                          : activeStatus.completed >= activeStatus.total
                            ? "bg-emerald-500"
                            : "bg-amber-400"
                      }`}
                      style={{
                        width: `${(activeStatus.completed / activeStatus.total) * 100}%`,
                      }}
                    />
                  </div>
                </div>

                {/* Card grid */}
                {setInfo.fotos.length === 0 ? (
                  <div className="text-center py-12 text-gray-400 text-sm">
                    No hay fotos definidas para este paso.
                  </div>
                ) : (
                  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3">
                    {setInfo.fotos.map((foto, index) => {
                      const secuencia = index + 1;
                      const evidencia = evidenciasList.find(
                        (ev) => ev.secuencia === secuencia,
                      );

                      return (
                        <div
                          key={secuencia}
                          className="bg-white border border-gray-200 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow group"
                        >
                          {/* Image area */}
                          <div className="relative h-28 bg-gray-50">
                            {evidencia ? (
                              <img
                                src={evidencia.urlArchivo}
                                alt={foto.nombre}
                                className="w-full h-full object-cover cursor-pointer"
                                onClick={() =>
                                  setImagePreview({
                                    src: evidencia.urlArchivo,
                                    nombre: foto.nombre,
                                  })
                                }
                              />
                            ) : (
                              <div className="w-full h-full flex items-center justify-center">
                                <div
                                  className={`w-12 h-12 rounded-full flex items-center justify-center ${
                                    foto.obligatorio
                                      ? "bg-red-100"
                                      : "bg-yellow-100"
                                  }`}
                                >
                                  <svg
                                    className={`h-5 w-5 ${
                                      foto.obligatorio
                                        ? "text-red-400"
                                        : "text-yellow-500"
                                    }`}
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth={2}
                                      d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                                    />
                                  </svg>
                                </div>
                              </div>
                            )}
                            {/* Badge */}
                            <div
                              className={`absolute top-1.5 right-1.5 px-1.5 py-0.5 rounded text-[10px] font-semibold ${
                                foto.obligatorio
                                  ? "bg-red-500 text-white"
                                  : "bg-blue-500 text-white"
                              }`}
                            >
                              {foto.obligatorio ? "Req" : "Opc"}
                            </div>
                            {/* Check overlay */}
                            {evidencia && (
                              <div className="absolute top-1.5 left-1.5 bg-emerald-500 text-white rounded-full p-0.5">
                                <CheckCircle className="h-3.5 w-3.5" />
                              </div>
                            )}
                          </div>

                          {/* Info */}
                          <div className="p-2.5">
                            <div className="flex items-start justify-between">
                              <span className="text-xs font-medium text-gray-900 leading-tight truncate flex-1" title={`${secuencia}. ${foto.nombre}`}>
                                {secuencia}. {foto.nombre}
                              </span>
                            </div>

                            {/* Actions */}
                            <div className="mt-2 flex items-center space-x-1.5">
                              {evidencia ? (
                                <>
                                  {evidenciasPermisos.can_delete_evidencias && (
                                    <button
                                      onClick={() => deleteEvidencia(secuencia)}
                                      className="flex-1 px-2 py-1 text-[10px] bg-red-50 text-red-600 hover:bg-red-100 rounded border border-red-200 transition-colors flex items-center justify-center"
                                    >
                                      <Trash2 className="h-3 w-3 mr-1" />
                                      Eliminar
                                    </button>
                                  )}
                                  {!evidenciasPermisos.can_create_evidencias &&
                                    evidenciasPermisos.can_view_evidencias && (
                                      <span className="flex-1 px-2 py-1 text-[10px] bg-green-50 text-green-600 rounded border border-green-200 flex items-center justify-center">
                                        <CheckCircle className="h-3 w-3 mr-1" />
                                        Subida
                                      </span>
                                    )}
                                </>
                              ) : (
                                <>
                                  {evidenciasPermisos.can_create_evidencias && (
                                    <button
                                      onClick={() => handleFileSelect(secuencia)}
                                      className="flex-1 px-2 py-1 text-[10px] bg-blue-50 text-blue-600 hover:bg-blue-100 rounded border border-blue-200 transition-colors flex items-center justify-center"
                                      disabled={uploading}
                                    >
                                      <Upload className="h-3 w-3 mr-1" />
                                      Cargar
                                    </button>
                                  )}
                                  {isMobile && evidenciasPermisos.can_create_evidencias && (
                                    <button
                                      onClick={() => capturePhoto(secuencia)}
                                      className="flex-1 px-2 py-1 text-[10px] bg-green-50 text-green-600 hover:bg-green-100 rounded border border-green-200 transition-colors flex items-center justify-center"
                                      disabled={uploading}
                                    >
                                      <svg
                                        className="h-3 w-3 mr-1"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth={2}
                                          d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
                                        />
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth={2}
                                          d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"
                                        />
                                      </svg>
                                      Foto
                                    </button>
                                  )}
                                  {!evidenciasPermisos.can_create_evidencias &&
                                    evidenciasPermisos.can_view_evidencias && (
                                      <span className="flex-1 px-2 py-1 text-[10px] bg-yellow-50 text-yellow-600 rounded border border-yellow-200 flex items-center justify-center">
                                        <Clock className="h-3 w-3 mr-1" />
                                        Pendiente
                                      </span>
                                    )}
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </>
            )}
          </div>

          {/* Footer */}
          <div className="bg-gray-50 px-5 py-2.5 border-t border-gray-200 flex items-center justify-between flex-shrink-0">
            <div className="flex items-center space-x-3 text-[10px] text-gray-500">
              <span className="flex items-center">
                <span className="w-2 h-2 bg-red-500 rounded-full mr-1"></span>
                Requerido
              </span>
              <span className="flex items-center">
                <span className="w-2 h-2 bg-blue-500 rounded-full mr-1"></span>
                Opcional
              </span>
            </div>
            <button
              onClick={() => setShowEvidenciasModal(false)}
              className="px-4 py-1.5 text-xs text-gray-600 bg-gray-200 hover:bg-gray-300 rounded-lg font-medium transition-colors"
            >
              Cerrar
            </button>
          </div>
        </div>

        {/* Image Preview Modal */}
        {imagePreview && (
          <div
            className="fixed inset-0 z-[200] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4"
            onClick={closeImagePreview}
          >
            <div className="relative max-w-5xl max-h-[90vh] w-full">
              <div className="absolute top-0 left-0 right-0 bg-gradient-to-b from-black/70 to-transparent p-4 z-10">
                <div className="flex items-center justify-between text-white">
                  <h3 className="text-lg font-semibold truncate pr-4">
                    {imagePreview.nombre}
                  </h3>
                  <button
                    onClick={closeImagePreview}
                    className="flex-shrink-0 p-2 hover:bg-white/20 rounded-full transition-colors"
                  >
                    <X className="h-6 w-6" />
                  </button>
                </div>
              </div>
              <div className="flex items-center justify-center h-full">
                <img
                  src={imagePreview.src}
                  alt={imagePreview.nombre}
                  className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl"
                  onClick={(e) => e.stopPropagation()}
                />
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4">
                <p className="text-white text-center text-sm">
                  Click fuera de la imagen para cerrar
                </p>
              </div>
            </div>
          </div>
        )}

        {/* Upload Preview Modal */}
        {showPreviewModal && previewImage && (
          <div className="fixed inset-0 z-[300] flex items-center justify-center bg-black/70 backdrop-blur-sm">
            <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full mx-4 overflow-hidden">
              <div className="bg-gradient-to-r from-blue-500 to-indigo-600 px-6 py-4">
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="text-lg font-bold text-white">
                      Vista Previa de Evidencia
                    </h3>
                    <p className="text-blue-100 text-sm mt-1">
                      Secuencia {previewImage.secuencia}: {previewImage.nombre}
                    </p>
                  </div>
                  <button
                    onClick={cancelarPreview}
                    className="text-white hover:bg-white/20 p-2 rounded-lg transition-colors"
                  >
                    <X className="h-5 w-5" />
                  </button>
                </div>
              </div>
              <div className="p-6">
                <div className="bg-gray-50 rounded-lg border-2 border-dashed border-gray-300 p-4 mb-4">
                  <img
                    src={previewImage.dataUrl}
                    alt="Preview"
                    className="max-w-full max-h-96 mx-auto object-contain rounded-lg"
                  />
                </div>
                <div className="grid grid-cols-2 gap-3 text-sm mb-6">
                  <div className="bg-gray-50 p-3 rounded-lg">
                    <span className="text-gray-600 font-medium">Tipo:</span>
                    <p className="text-gray-900">{previewImage.tipo}</p>
                  </div>
                  <div className="bg-gray-50 p-3 rounded-lg">
                    <span className="text-gray-600 font-medium">Tamaño:</span>
                    <p className="text-gray-900">
                      {(previewImage.tamanio / 1024).toFixed(2)} KB
                    </p>
                  </div>
                </div>
                <div className="flex space-x-3">
                  <button
                    onClick={cancelarPreview}
                    disabled={uploading}
                    className="flex-1 px-4 py-3 text-gray-700 bg-gray-200 hover:bg-gray-300 rounded-lg font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Cancelar
                  </button>
                  <button
                    onClick={confirmarYSubirEvidencia}
                    disabled={uploading}
                    className="flex-1 px-4 py-3 text-white bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-600 hover:to-teal-700 rounded-lg font-medium transition-all shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                  >
                    {uploading ? (
                      <>
                        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                        Subiendo...
                      </>
                    ) : (
                      <>
                        <Upload className="h-5 w-5 mr-2" />
                        Confirmar y Subir
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };
  // Componente Modal de Alert
  const renderAlertModal = () => {
    if (!showAlert) return null;

    const getAlertIcon = () => {
      switch (alertConfig.type) {
        case "success":
          return <CheckCircle className="h-6 w-6 text-green-500" />;
        case "error":
          return <AlertCircle className="h-6 w-6 text-red-500" />;
        case "warning":
          return <AlertCircle className="h-6 w-6 text-yellow-500" />;
        default:
          return <AlertCircle className="h-6 w-6 text-blue-500" />;
      }
    };

    const getAlertColors = () => {
      switch (alertConfig.type) {
        case "success":
          return "from-green-500 to-emerald-600";
        case "error":
          return "from-red-500 to-red-600";
        case "warning":
          return "from-yellow-500 to-orange-600";
        default:
          return "from-blue-500 to-blue-600";
      }
    };

    return (
      <div
        className="fixed inset-0 flex items-center justify-center"
        style={{ zIndex: 9999999 }}
      >
        <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" />

        <div className="relative bg-white/95 backdrop-blur-md rounded-xl shadow-2xl border border-white/20 max-w-md mx-4 overflow-hidden">
          {/* Header */}
          <div
            className={`bg-gradient-to-r ${getAlertColors()} px-6 py-4 text-white`}
          >
            <div className="flex items-center">
              {getAlertIcon()}
              <h3 className="text-lg font-semibold ml-3">
                {alertConfig.title}
              </h3>
            </div>
          </div>

          {/* Content */}
          <div className="p-6">
            <p className="text-gray-700 mb-6">{alertConfig.message}</p>

            <div className="flex justify-end space-x-3">
              {alertConfig.showCancel && (
                <button
                  onClick={() => setShowAlert(false)}
                  className="px-4 py-2 text-gray-700 bg-gray-200 hover:bg-gray-300 rounded-lg font-medium transition-all duration-200 text-sm"
                >
                  Cancelar
                </button>
              )}
              <button
                onClick={() => {
                  setShowAlert(false);
                  if (alertConfig.onConfirm) {
                    alertConfig.onConfirm();
                  }
                }}
                className={`px-4 py-2 text-white bg-gradient-to-r ${getAlertColors()} hover:opacity-90 rounded-lg font-medium transition-all duration-200 text-sm flex items-center`}
              >
                {alertConfig.showCancel ? "Confirmar" : "Aceptar"}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };
  console.log("Viaje seleccionado:", selectedViaje);

  console.log("Inicio real:", selectedViaje?.tramos?.[0]?.horaLlegadaReal);

  console.log(
    "Finalizado:",
    selectedViaje?.tramos?.[selectedViaje?.tramos?.length - 1]
      ?.horaSalidaRealDestino,
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50 to-indigo-100">
      {(loading || loadingFormulario || isDeleting || isSaving) && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 flex items-center space-x-4 shadow-xl">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-emerald-600"></div>
            <span className="text-gray-700 font-medium">
              {loadingMessage || "Procesando..."}
            </span>
          </div>
        </div>
      )}
      {showSeguimiento ? (
        <SeguimientoViajes onVolverAtras={() => setShowSeguimiento(false)} />
      ) : (
        <>
          {/* Header */}
          <div className="bg-white shadow-sm border-b border-gray-200 mb-4">
            <div className="px-4 py-3">
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 md:gap-3">
                <div className="flex items-center">
                  <div className="bg-gradient-to-r from-emerald-500 to-teal-600 p-2 rounded-lg mr-3">
                    <Package className="h-5 w-5 text-white" />
                  </div>
                  <div>
                    <h1 className="text-xl font-bold text-gray-900">
                      Gestión de Viajes
                    </h1>
                    <p className="text-sm text-gray-600">
                      Administra los viajes de transporte
                    </p>
                  </div>
                </div>

                <div className="flex items-center space-x-1 md:space-x-2">
                  <button
                    onClick={() => setShowSeguimiento(true)}
                    className="px-2 md:px-4 py-2 text-blue-700 bg-blue-100 hover:bg-blue-200 rounded-lg font-medium transition-all duration-200 text-xs md:text-sm flex items-center"
                  >
                    <Navigation className="w-3 md:w-4 h-3 md:h-4 mr-1 md:mr-2" />
                    <span className="hidden sm:inline">Seguimiento</span>
                    <span className="sm:hidden">GPS</span>
                  </button>
                  {/* ✅ AGREGAR CLASE dropdown-container AQUÍ */}
                  {userRole === "transportista" && (
                    <div className="relative dropdown-container">
                      {" "}
                      {/* ✅ AGREGAR ESTA CLASE */}
                      <button
                        onClick={() => {
                          console.log("🖱️ CLICK EN BOTÓN REPORTE");
                          setShowDropdown((prev) => {
                            const newState = {
                              ...prev,
                              reporteGeneral: !prev.reporteGeneral,
                            };
                            console.log("📊 Nuevo estado dropdown:", newState);
                            return newState;
                          });
                        }}
                        className="px-2 md:px-4 py-2 text-purple-700 bg-purple-100 hover:bg-purple-200 rounded-lg font-medium transition-all duration-200 text-xs md:text-sm flex items-center"
                      >
                        <Download className="w-3 md:w-4 h-3 md:h-4 mr-1 md:mr-2" />
                        <span className="hidden sm:inline">Reporte</span>
                        <span className="sm:hidden">📊</span>
                      </button>
                      {/* DROPDOWN DE REPORTES */}
                      {showDropdown.reporteGeneral && (
                        <div className="absolute right-0 mt-2 w-56 bg-white border border-gray-200 rounded-lg shadow-xl z-50">
                          <div className="py-1">
                            {/* TÍTULO */}
                            <div className="px-4 py-2 bg-gradient-to-r from-purple-50 to-indigo-50 border-b border-gray-100">
                              <p className="text-xs font-semibold text-gray-700">
                                Descargar Reporte General
                              </p>
                            </div>

                            {/* OPCIÓN PDF */}
                            <button
                              type="button"
                              onClick={() => {
                                handleDownloadReporte("pdf");
                                // ✅ Cerrar dropdown después de hacer click
                                setShowDropdown((prev) => ({
                                  ...prev,
                                  reporteGeneral: false,
                                }));
                              }}
                              className="w-full flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-red-50 hover:text-red-600 transition-colors"
                            >
                              <svg
                                className="h-5 w-5 mr-3 text-red-500"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z" />
                              </svg>
                              <div className="text-left">
                                <p className="font-medium">PDF</p>
                                <p className="text-xs text-gray-500">
                                  Tabla de viajes
                                </p>
                              </div>
                            </button>

                            {/* OPCIÓN EXCEL */}
                            <button
                              type="button"
                              onClick={() => {
                                handleDownloadReporte("excel");
                                // ✅ Cerrar dropdown después de hacer click
                                setShowDropdown((prev) => ({
                                  ...prev,
                                  reporteGeneral: false,
                                }));
                              }}
                              className="w-full flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 transition-colors border-t border-gray-100"
                            >
                              <svg
                                className="h-5 w-5 mr-3 text-green-500"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path d="M9 2a2 2 0 00-2 2v8a2 2 0 002 2h6a2 2 0 002-2V6.414A2 2 0 0016.414 5L14 2.586A2 2 0 0012.586 2H9z" />
                                <path d="M3 8a2 2 0 012-2v10h8a2 2 0 01-2 2H5a2 2 0 01-2-2V8z" />
                              </svg>
                              <div className="text-left">
                                <p className="font-medium">Excel</p>
                                <p className="text-xs text-gray-500">
                                  Con estadísticas
                                </p>
                              </div>
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  {userRole !== "conductor" && (
                    <button
                      onClick={handleCreateViaje}
                      className="px-2 md:px-4 py-2 text-white bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-600 hover:to-teal-700 rounded-lg font-medium transition-all duration-200 text-xs md:text-sm flex items-center shadow-lg hover:shadow-xl"
                    >
                      <Plus className="w-3 md:w-4 h-3 md:h-4 mr-1 md:mr-2" />
                      <span className="hidden sm:inline">Nuevo Viaje</span>
                      <span className="sm:hidden">Nuevo</span>
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>

           {/* Content */}
          <div className="px-4">
            <ViajesDashboard
              viajes={viajes}
              userRole={userRole}
              onFilterChange={(filtrados) =>
                setViajesFiltradosDashboard(filtrados)
              }
            />
            {/* Barra de búsqueda simplificada */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-3 mb-4">
              <div className="relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
                <input
                  type="text"
                  placeholder="Buscar por código, transportista o cliente..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 text-sm placeholder:text-gray-400"
                />
              </div>
            </div>
            <div className="flex items-center gap-2">
              <input
                type="date"
                value={fechaDesde}
                onChange={(e) => setFechaDesde(e.target.value)}
                className="px-2 py-2 text-sm border border-gray-300 rounded-lg"
              />
              <span className="text-gray-500 text-sm">—</span>
              <input
                type="date"
                value={fechaHasta}
                onChange={(e) => setFechaHasta(e.target.value)}
                className="px-2 py-2 text-sm border border-gray-300 rounded-lg"
              />
            <button
              onClick={() => fetchViajesLista(fechaDesde, fechaHasta)}  // ✅
              className="px-3 py-2 bg-emerald-600 text-white text-sm rounded-lg hover:bg-emerald-700"
            >
              Buscar
            </button>
            </div>

            {/* Tabla */}
            <div className="hidden md:block bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  {userRole === "conductor" ? (
                    // Tabla para conductores
                    <thead className="bg-gray-50 border-b border-gray-200">
                      <tr>
                        <th className="px-4 py-3 text-left font-medium text-gray-700 w-32">
                          N° Viaje
                        </th>
                        <th className="px-4 py-3 text-left font-medium text-gray-700">
                          Operación
                        </th>
                        <th className="px-4 py-3 text-left font-medium text-gray-700 w-48">
                          Origen → Destino
                        </th>
                        <th className="px-4 py-3 text-left font-medium text-gray-700">
                          Cliente
                        </th>
                        <th className="px-4 py-3 text-left font-medium text-gray-700">
                          Transportista
                        </th>
                        <th className="px-4 py-3 text-left font-medium text-gray-700">
                          Fecha Inicio
                        </th>
                        <th className="px-4 py-3 text-left font-medium text-gray-700">
                          Estado
                        </th>

                        {/* ✅ Esto ahora funcionará para ambos roles */}
                        {(userRole === "cliente" ||
                          userRole === "conductor") && (
                            <th className="px-4 py-3 text-center font-medium text-gray-700 w-32">
                              Evidencias
                            </th>
                          )}

                        <th className="px-4 py-3 text-center font-medium text-gray-700 w-24">
                          Acciones
                        </th>
                      </tr>
                    </thead>
                  ) : (
                    <thead className="bg-gray-50 border-b border-gray-200">
                      <tr>
                        <th
                          className="px-4 py-3 text-left font-medium text-gray-700 w-32 cursor-pointer hover:bg-gray-100 select-none"
                          onClick={() => handleSort("codigoViaje")}
                        >
                          <div className="flex items-center justify-between">
                            N° Viaje
                            {getSortIcon("codigoViaje")}
                          </div>
                        </th>
                        <th
                          className="px-4 py-3 text-left font-medium text-gray-700 cursor-pointer hover:bg-gray-100 select-none"
                          onClick={() => handleSort("tipoOperacion")}
                        >
                          <div className="flex items-center justify-between">
                            Operación
                            {getSortIcon("tipoOperacion")}
                          </div>
                        </th>
                        <th className="px-4 py-3 text-left font-medium text-gray-700 w-48">
                          Origen → Destino
                        </th>
                        <th
                          className="px-4 py-3 text-left font-medium text-gray-700 cursor-pointer hover:bg-gray-100 select-none"
                          onClick={() => handleSort("cliente")}
                        >
                          <div className="flex items-center justify-between">
                            Cliente
                            {getSortIcon("cliente")}
                          </div>
                        </th>
                        <th
                          className="px-4 py-3 text-left font-medium text-gray-700 cursor-pointer hover:bg-gray-100 select-none"
                          onClick={() => handleSort("transportista")}
                        >
                          <div className="flex items-center justify-between">
                            Transportista
                            {getSortIcon("transportista")}
                          </div>
                        </th>
                        <th
                          className="px-4 py-3 text-left font-medium text-gray-700 cursor-pointer hover:bg-gray-100 select-none"
                          onClick={() => handleSort("fechaInicioProgramada")}
                        >
                          <div className="flex items-center justify-between">
                            Fecha Inicio
                            {getSortIcon("fechaInicioProgramada")}
                          </div>
                        </th>
                        <th
                          className="px-4 py-3 text-left font-medium text-gray-700 cursor-pointer hover:bg-gray-100 select-none"
                          onClick={() => handleSort("estado")}
                        >
                          <div className="flex items-center justify-between">
                            Estado
                            {getSortIcon("estado")}
                          </div>
                        </th>

                        {/* ✅ COLUMNA EVIDENCIAS - Basado en permisos */}
                        {evidenciasPermisos.can_view_evidencias && (
                          <th className="px-4 py-3 text-center font-medium text-gray-700 w-32">
                            Evidencias
                          </th>
                        )}

                        <th className="px-4 py-3 text-center font-medium text-gray-700 w-32">
                          Acciones
                        </th>
                      </tr>
                    </thead>
                  )}
                  <tbody className="divide-y divide-gray-200">
                    {loadingTabla ? (
                    // ← PRIMERO: mientras carga
                    [...Array(5)].map((_, i) => (
                      <tr key={i} className="animate-pulse">
                        <td className="px-4 py-3"><div className="h-4 bg-gray-200 rounded w-24"/></td>
                        <td className="px-4 py-3"><div className="h-4 bg-gray-200 rounded w-16"/></td>
                        <td className="px-4 py-3"><div className="h-4 bg-gray-200 rounded w-32"/></td>
                        <td className="px-4 py-3"><div className="h-4 bg-gray-200 rounded w-28"/></td>
                        <td className="px-4 py-3"><div className="h-4 bg-gray-200 rounded w-28"/></td>
                        <td className="px-4 py-3"><div className="h-4 bg-gray-200 rounded w-20"/></td>
                        <td className="px-4 py-3"><div className="h-4 bg-gray-200 rounded w-16"/></td>
                        <td className="px-4 py-3"><div className="h-4 bg-gray-200 rounded w-20"/></td>
                      </tr>
                    ))
                  ) : currentViajes.length === 0 ? (
                    // ← SEGUNDO: si no hay datos
                    <tr>
                      <td colSpan="8" className="text-center py-8 text-gray-500">
                        No hay viajes
                      </td>
                    </tr>
                  ) : (currentViajes.map((viaje) => (
                      <tr
                        key={viaje.id}
                        className="hover:bg-gray-50 transition-colors duration-150"
                      >
                        <td className="px-4 py-3">
                          <div className="flex items-center space-x-2 mb-1">
                            <span className="px-2 py-1 bg-gradient-to-r from-blue-500 to-blue-600 text-white text-xs font-bold rounded-full">
                              {viaje.correlativo || "N/A"}
                            </span>
                          </div>
                          <div className="font-medium text-gray-900">
                            {viaje.codigoViaje}
                          </div>
                          <div className="text-xs text-gray-500">
                            {viaje.vehiculoPlaca || "Sin vehículo asignado"}
                          </div>
                        </td>
                        <td className="px-4 py-3">
                          <span
                            className={`px-2 py-1 rounded-full text-xs font-medium ${viaje.tipoOperacion === "exportacion"
                              ? "bg-green-100 text-green-800"
                              : "bg-blue-100 text-blue-800"
                              }`}
                          >
                            {viaje.tipoOperacion.charAt(0).toUpperCase() +
                              viaje.tipoOperacion.slice(1)}
                          </span>
                        </td>
                        <td className="px-4 py-3 w-48">
                      <span className="text-gray-600 text-sm block max-w-[192px] break-words">
                        {viaje.origenNombre && viaje.destinoNombre
                          ? `${viaje.origenNombre} → ${viaje.destinoNombre}`
                          : "Sin tramos"}
                      </span>
                        </td>
                        <td className="px-4 py-3">
                        <div className="font-medium text-gray-900">
                          {viaje.clienteNombre || "Sin cliente"}
                        </div>
                        </td>
                        <td className="px-4 py-3">
                          <div className="font-medium text-gray-900">
                            {viaje.transportistaNombre}
                          </div>
                          <div className="text-xs text-gray-500">
                          {viaje.conductorNombre || "Sin conductor"}
                        </div>
                        </td>
                        <td className="px-4 py-3">
                          <div className="text-gray-900">
                            {viaje.fechaInicioProgramada
                              ? new Date(
                                viaje.fechaInicioProgramada,
                              ).toLocaleDateString()
                              : "No programada"}
                          </div>
                          <div className="text-xs text-gray-500">
                            {viaje.fechaInicioProgramada
                              ? new Date(
                                viaje.fechaInicioProgramada,
                              ).toLocaleTimeString()
                              : ""}
                          </div>
                        </td>
                        <td className="px-4 py-3">
                          <span
                            className={`px-3 py-1 rounded-full text-xs font-medium flex items-center w-fit ${getStatusColor(
                              viaje.estado,
                            )}`}
                          >
                            {getStatusIcon(viaje.estado)}
                            <span className="ml-1">
                              {viaje.estado.replace("_", " ").toUpperCase()}
                            </span>
                          </span>
                        </td>

                        {evidenciasPermisos.can_view_evidencias && (
                          <td className="px-4 py-3 text-center">
                            <div className="relative dropdown-container inline-block">
                              {/* Botón con ref */}
                              <button
                                ref={(el) => {
                                  if (el) {
                                    buttonRefs.current[viaje.id] = el;
                                  }
                                }}
                                onClick={() => handleEvidenciaSelect("1", viaje)}
                                className={`w-10 h-10 rounded-lg flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 ${evidenciasPermisos.can_create_evidencias
                                  ? "bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 text-white focus:ring-blue-500"
                                  : "bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white focus:ring-green-500"
                                  }`}
                                title={
                                  evidenciasPermisos.can_create_evidencias
                                    ? "Gestionar evidencias"
                                    : "Ver evidencias"
                                }
                              >
                                {evidenciasPermisos.can_create_evidencias ? (
                                  <Package className="h-5 w-5" />
                                ) : (
                                  <Eye className="h-5 w-5" />
                                )}
                              </button>

                              {/* Dropdown con posición dinámica */}
                              {showDropdown[viaje.id] && (
                                <div
                                  className={`absolute right-0 w-80 bg-white border border-gray-200 rounded-xl shadow-xl z-50 overflow-hidden ${dropdownPositions[viaje.id] === "top"
                                    ? "bottom-full mb-2"
                                    : "top-full mt-2"
                                    }`}
                                  style={{
                                    maxHeight:
                                      dropdownPositions[viaje.id] === "top"
                                        ? "50vh"
                                        : "60vh",
                                  }}
                                >
                                  {/* Header del dropdown */}
                                  <div className="bg-gradient-to-r from-blue-50 to-indigo-50 px-4 py-3 border-b border-gray-100">
                                    <h3 className="text-sm font-semibold text-gray-800 flex items-center">
                                      <Package className="h-4 w-4 text-blue-600 mr-2" />
                                      {evidenciasPermisos.can_create_evidencias
                                        ? "Gestionar Evidencias"
                                        : "Ver Evidencias"}
                                    </h3>
                                  </div>

                                  {/* Lista de sets con scroll si es necesario */}
                                  <div className="py-2 max-h-64 overflow-y-auto">
                                    {Object.entries(evidenciasSets).map(
                                      ([key, set]) => (
                                        <button
                                          key={key}
                                          onClick={() =>
                                            handleEvidenciaSelectFromDropdown(
                                              key,
                                              viaje,
                                            )
                                          }
                                          className="w-full px-4 py-3 text-left hover:bg-blue-50 transition-colors duration-150 flex items-center justify-between group"
                                        >
                                          <div className="flex items-center">
                                            <div className="flex items-center justify-center w-8 h-8 rounded-full bg-gradient-to-r from-blue-500 to-indigo-600 text-white text-sm font-bold mr-3 group-hover:scale-105 transition-transform">
                                              {key}
                                            </div>
                                            <div className="text-sm font-medium text-gray-900 group-hover:text-blue-900">
                                              {set.nombre}
                                            </div>
                                          </div>
                                          <ArrowRight className="h-4 w-4 text-gray-400 group-hover:text-blue-600 opacity-0 group-hover:opacity-100 transition-all" />
                                        </button>
                                      ),
                                    )}
                                  </div>

                                  {/* Footer */}
                                  <div className="border-t border-gray-100 px-4 py-2 bg-gray-50">
                                    <p className="text-xs text-gray-600 text-center">
                                      Viaje: {viaje.codigoViaje}
                                    </p>
                                  </div>
                                </div>
                              )}
                            </div>
                          </td>
                        )}
                        <td className="px-4 py-3">
                          <div className="flex items-center justify-center space-x-2">
                            <button
                              onClick={() => handleViewViaje(viaje)}
                              className="p-1 text-blue-600 hover:text-blue-800 hover:bg-blue-100 rounded transition-colors duration-150"
                              title="Ver detalles"
                            >
                              <Eye className="h-4 w-4" />
                            </button>
                            <button
                              onClick={() => { setReplayViaje(viaje); setShowReplay(true); }}
                              className="p-1 text-purple-600 hover:text-purple-800 hover:bg-purple-100 rounded transition-colors duration-150"
                              title="Replay GPS"
                            >
                              <Play className="h-4 w-4" />
                            </button>
                            {userRole !== "conductor" && (
                              <>
                                {/* BOTÓN EDITAR - Solo mostrar si está pendiente */}
                                {viaje.estado === "pendiente" && (
                                  <button
                                    onClick={() => handleEditViaje(viaje)}
                                    className="p-1 text-emerald-600 hover:text-emerald-800 hover:bg-emerald-100 rounded transition-colors duration-150"
                                    title="Editar"
                                  >
                                    <Edit className="h-4 w-4" />
                                  </button>
                                )}

                                {/* BOTÓN ELIMINAR - Solo mostrar si está pendiente */}
                                {viaje.estado === "pendiente" && (
                                  <button
                                    onClick={() => deleteViaje(viaje)}
                                    disabled={isDeleting || loading}
                                    className="text-red-600 hover:text-red-800 disabled:text-gray-400"
                                    title="Eliminar viaje"
                                  >
                                    <TrashIcon className="w-5 h-5" />
                                  </button>
                                )}
                              </>
                            )}
                          </div>
                        </td>
                      </tr>
                        ))
                      )}
                    </tbody>
                </table>
              </div>

              {/* Paginación moderna */}
              <div className="bg-gray-50 px-3 md:px-4 py-3 border-t border-gray-200 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                {/* Info de página */}
                <div className="text-xs text-gray-600">
                  Mostrando&nbsp;
                  <span className="font-medium text-gray-800">
                    {filteredViajes.length === 0 ? 0 : startIndex + 1}
                  </span>
                  &nbsp;-&nbsp;
                  <span className="font-medium text-gray-800">
                    {Math.min(
                      startIndex + currentViajes.length,
                      filteredViajes.length,
                    )}
                  </span>
                  &nbsp;de&nbsp;
                  <span className="font-medium text-gray-800">
                    {filteredViajes.length}
                  </span>
                  &nbsp; viajes
                </div>

                {/* Controles */}
                <div className="flex items-center justify-center space-x-1">
                  {/* Botón anterior */}
                  <button
                    onClick={() =>
                      currentPage > 1 && setCurrentPage(currentPage - 1)
                    }
                    disabled={currentPage === 1}
                    className={`flex items-center justify-center px-3 py-1.5 rounded-md text-sm font-medium transition-all duration-150
                      ${currentPage === 1
                        ? "text-gray-400 bg-gray-100 cursor-not-allowed"
                        : "text-gray-700 bg-white hover:bg-gray-100 border border-gray-300"
                      }`}
                  >
                    ← Anterior
                  </button>

                  {/* Números de página */}
                  {Array.from(
                    { length: Math.ceil(viajes.length / itemsPerPage) },
                    (_, i) => i + 1,
                  )
                    .slice(
                      Math.max(currentPage - 2, 0),
                      Math.min(
                        currentPage + 1,
                        Math.ceil(viajes.length / itemsPerPage),
                      ),
                    )
                    .map((page) => (
                      <button
                        key={page}
                        onClick={() => setCurrentPage(page)}
                        className={`w-8 h-8 rounded-md text-sm font-medium transition-all duration-150
                          ${currentPage === page
                            ? "bg-gradient-to-r from-blue-500 to-indigo-600 text-white shadow-sm"
                            : "bg-white text-gray-700 border border-gray-300 hover:bg-gray-100"
                          }`}
                      >
                        {page}
                      </button>
                    ))}

                  {/* Botón siguiente */}
                  <button
                    onClick={() =>
                      currentPage < Math.ceil(viajes.length / itemsPerPage) &&
                      setCurrentPage(currentPage + 1)
                    }
                    disabled={
                      currentPage >= Math.ceil(viajes.length / itemsPerPage)
                    }
                    className={`flex items-center justify-center px-3 py-1.5 rounded-md text-sm font-medium transition-all duration-150
                      ${currentPage >= Math.ceil(viajes.length / itemsPerPage)
                        ? "text-gray-400 bg-gray-100 cursor-not-allowed"
                        : "text-gray-700 bg-white hover:bg-gray-100 border border-gray-300"
                      }`}
                  >
                    Siguiente →
                  </button>
                </div>
              </div>
            </div>

            {/* Vista Cards Móvil */}
            <div className="md:hidden space-y-3">
              {currentViajes.map((viaje) => (
                <div
                  key={viaje.id}
                  className="bg-white rounded-lg shadow-sm border border-gray-200 p-4"
                >
                  {/* Header de la card */}
                  <div className="flex items-center justify-between mb-3">
                    <div>
                      <div className="flex items-center space-x-2 mb-1">
                        <span className="px-2 py-1 bg-gradient-to-r from-blue-500 to-blue-600 text-white text-xs font-bold rounded-full">
                          {viaje.correlativo || "N/A"}
                        </span>
                      </div>
                      <h3 className="font-medium text-gray-900">
                        {viaje.codigoViaje}
                      </h3>
                      <span
                        className={`px-2 py-1 rounded-full text-xs font-medium ${viaje.tipoOperacion === "exportacion"
                          ? "bg-green-100 text-green-800"
                          : "bg-blue-100 text-blue-800"
                          }`}
                      >
                        {viaje.tipoOperacion.charAt(0).toUpperCase() +
                          viaje.tipoOperacion.slice(1)}
                      </span>
                    </div>
                    <span
                      className={`px-2 py-1 rounded-full text-xs font-medium flex items-center ${getStatusColor(
                        viaje.estado,
                      )}`}
                    >
                      {getStatusIcon(viaje.estado)}
                      <span className="ml-1">
                        {viaje.estado.replace("_", " ").toUpperCase()}
                      </span>
                    </span>
                  </div>

                  {/* Contenido de la card */}
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span className="text-gray-500">Transportista:</span>
                     <span className="text-gray-900 text-right">
                      {viaje.transportistaNombre}
                    </span>
                    </div>

                    {userRole === "conductor" && (
                      <div className="flex justify-between">
                        <span className="text-gray-500">Cliente:</span>
                        <span className="text-gray-900 text-right">
                          {viaje.clienteNombre || "No asignado"}
                        </span>
                      </div>
                    )}

                    <div className="flex justify-between">
                      <span className="text-gray-500">Ruta:</span>
                      <span className="text-gray-900 text-right text-xs">
                      {viaje.origenNombre && viaje.destinoNombre
                        ? `${viaje.origenNombre} → ${viaje.destinoNombre}`
                        : "Sin tramos"}
                      </span>
                    </div>

                    <div className="flex justify-between">
                      <span className="text-gray-500">Fecha:</span>
                      <span className="text-gray-900">
                        {viaje.fechaInicioProgramada
                          ? new Date(
                            viaje.fechaInicioProgramada,
                          ).toLocaleDateString()
                          : "No programada"}
                      </span>
                    </div>

                    {viaje.vehiculo?.placa && (
                      <div className="flex justify-between">
                        <span className="text-gray-500">Vehículo:</span>
                        <span className="text-gray-900">
                        {viaje.vehiculoPlaca}
                        </span>
                      </div>
                    )}
                  </div>

                  {/* Acciones móvil */}
                  <div className="mt-4 pt-3 border-t border-gray-100">
                    <div className="flex items-center justify-between">
                      {evidenciasPermisos.can_view_evidencias && (
                        <button
                          onClick={() => handleEvidenciaSelect("1", viaje)}
                          className={`flex items-center justify-center px-4 py-2 text-xs font-medium rounded-lg shadow transition-all ${
                            evidenciasPermisos.can_create_evidencias
                              ? "bg-gradient-to-r from-blue-500 to-indigo-600 text-white hover:from-blue-600 hover:to-indigo-700"
                              : "bg-gradient-to-r from-green-500 to-emerald-600 text-white hover:from-green-600 hover:to-emerald-700"
                          }`}
                        >
                          {evidenciasPermisos.can_create_evidencias ? (
                            <Package className="h-4 w-4 mr-1.5" />
                          ) : (
                            <Eye className="h-4 w-4 mr-1.5" />
                          )}
                          {evidenciasPermisos.can_create_evidencias
                            ? "Evidencias"
                            : "Ver evidencias"}
                        </button>
                      )}

                      <div
                        className={`flex items-center space-x-2 ${userRole === "cliente" || userRole === "conductor"
                          ? ""
                          : "ml-auto"
                          }`}
                      >
                        {/* VER - Todos pueden ver */}
                        <button
                          onClick={() => handleViewViaje(viaje)}
                          className="p-2 text-blue-600 hover:text-blue-800 hover:bg-blue-100 rounded-lg transition-colors"
                          title="Ver detalles"
                        >
                          <Eye className="h-4 w-4" />
                        </button>

                        {/* EDITAR/ELIMINAR - Solo transportistas y operadores */}
                        {(userRole === "transportista" ||
                          userRole === "operador_logistico") && (
                            <>
                              {viaje.estado === "pendiente" && (
                                <>
                                  <button
                                    onClick={() => handleEditViaje(viaje)}
                                    className="p-2 text-emerald-600 hover:text-emerald-800 hover:bg-emerald-100 rounded-lg transition-colors"
                                    title="Editar"
                                  >
                                    <Edit className="h-4 w-4" />
                                  </button>
                                  <button
                                    onClick={() => deleteViaje(viaje)}
                                    className="p-2 text-red-600 hover:text-red-800 hover:bg-red-100 rounded-lg transition-colors"
                                    title="Eliminar"
                                  >
                                    <Trash2 className="h-4 w-4" />
                                  </button>
                                </>
                              )}
                            </>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Modal de visualización */}
          {renderViewModal()}

          {/* Modal de Alert */}
          {renderAlertModal()}
          {renderEvidenciasModal()}

          {/* Modal Replay GPS */}
          {showReplay && replayViaje && (
            <ReplayViaje
              viaje={replayViaje}
              onClose={() => { setShowReplay(false); setReplayViaje(null); }}
            />
          )}
        </>
      )}
      {/* Modal de Previsualización de PDF */}
      <PdfPreviewModal
        isOpen={showPdfPreview}
        onClose={() => setShowPdfPreview(false)}
        pdfUrl={pdfPreviewUrl}
        title={`Reporte de Viaje: ${selectedViaje?.codigoViaje || ""}`}
      />
    </div>
  );
};

export default Viajes;














